/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReportsRouteRouteImport } from './routes/reports/route'
import { Route as FinanceRouteRouteImport } from './routes/finance/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerifyEmailIndexRouteImport } from './routes/verify-email/index'
import { Route as Verify2faIndexRouteImport } from './routes/verify-2fa/index'
import { Route as StockLocationsIndexRouteImport } from './routes/stock-locations/index'
import { Route as SignupIndexRouteImport } from './routes/signup/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SelectStoreIndexRouteImport } from './routes/select-store/index'
import { Route as SalesChannelsIndexRouteImport } from './routes/sales-channels/index'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as ProductTemplatesIndexRouteImport } from './routes/product-templates/index'
import { Route as ProductPropertiesIndexRouteImport } from './routes/product-properties/index'
import { Route as PagesIndexRouteImport } from './routes/pages/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as MarketingIndexRouteImport } from './routes/marketing/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as InventoryIndexRouteImport } from './routes/inventory/index'
import { Route as GiftCardsIndexRouteImport } from './routes/gift-cards/index'
import { Route as FinanceIndexRouteImport } from './routes/finance/index'
import { Route as FiltersIndexRouteImport } from './routes/filters/index'
import { Route as FacetsIndexRouteImport } from './routes/facets/index'
import { Route as CustomersIndexRouteImport } from './routes/customers/index'
import { Route as CollectionsIndexRouteImport } from './routes/collections/index'
import { Route as CategoriesIndexRouteImport } from './routes/categories/index'
import { Route as CapabilitiesIndexRouteImport } from './routes/capabilities/index'
import { Route as BrandsIndexRouteImport } from './routes/brands/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as AttributesIndexRouteImport } from './routes/attributes/index'
import { Route as AcceptInviteIndexRouteImport } from './routes/accept-invite/index'
import { Route as SalesChannelsMobileAppRouteRouteImport } from './routes/sales-channels/mobile-app/route'
import { Route as StockLocationsNewIndexRouteImport } from './routes/stock-locations/new/index'
import { Route as StockLocationsIdIndexRouteImport } from './routes/stock-locations/$id/index'
import { Route as SettingsTestimonialsIndexRouteImport } from './routes/settings/testimonials/index'
import { Route as SettingsTaxIndexRouteImport } from './routes/settings/tax/index'
import { Route as SettingsStoreIndexRouteImport } from './routes/settings/store/index'
import { Route as SettingsStaffIndexRouteImport } from './routes/settings/staff/index'
import { Route as SettingsShippingIndexRouteImport } from './routes/settings/shipping/index'
import { Route as SettingsSecurityIndexRouteImport } from './routes/settings/security/index'
import { Route as SettingsSchedulingIndexRouteImport } from './routes/settings/scheduling/index'
import { Route as SettingsReturnPolicyIndexRouteImport } from './routes/settings/return-policy/index'
import { Route as SettingsProfileIndexRouteImport } from './routes/settings/profile/index'
import { Route as SettingsPaymentMethodsIndexRouteImport } from './routes/settings/payment-methods/index'
import { Route as SettingsOrderCustomizationsIndexRouteImport } from './routes/settings/order-customizations/index'
import { Route as SettingsOperationsIndexRouteImport } from './routes/settings/operations/index'
import { Route as SettingsNotificationsIndexRouteImport } from './routes/settings/notifications/index'
import { Route as SettingsMetafieldDefinitionsIndexRouteImport } from './routes/settings/metafield-definitions/index'
import { Route as SettingsMessagingIndexRouteImport } from './routes/settings/messaging/index'
import { Route as SettingsMarketsIndexRouteImport } from './routes/settings/markets/index'
import { Route as SettingsLocalizationIndexRouteImport } from './routes/settings/localization/index'
import { Route as SettingsLanguagesIndexRouteImport } from './routes/settings/languages/index'
import { Route as SettingsInvoicesIndexRouteImport } from './routes/settings/invoices/index'
import { Route as SettingsInventoryIndexRouteImport } from './routes/settings/inventory/index'
import { Route as SettingsIntegrationsIndexRouteImport } from './routes/settings/integrations/index'
import { Route as SettingsGiftOptionsIndexRouteImport } from './routes/settings/gift-options/index'
import { Route as SettingsDomainsIndexRouteImport } from './routes/settings/domains/index'
import { Route as SettingsDataMigrationIndexRouteImport } from './routes/settings/data-migration/index'
import { Route as SettingsContentBlocksIndexRouteImport } from './routes/settings/content-blocks/index'
import { Route as SettingsCheckoutIndexRouteImport } from './routes/settings/checkout/index'
import { Route as SettingsCheckoutRiskIndexRouteImport } from './routes/settings/checkout-risk/index'
import { Route as SettingsCheckoutRestrictionsIndexRouteImport } from './routes/settings/checkout-restrictions/index'
import { Route as SettingsBillingIndexRouteImport } from './routes/settings/billing/index'
import { Route as SettingsAppsIndexRouteImport } from './routes/settings/apps/index'
import { Route as SalesChannelsPosIndexRouteImport } from './routes/sales-channels/pos/index'
import { Route as SalesChannelsOnlineStoreIndexRouteImport } from './routes/sales-channels/online-store/index'
import { Route as SalesChannelsMobileAppIndexRouteImport } from './routes/sales-channels/mobile-app/index'
import { Route as ReportsSalesIndexRouteImport } from './routes/reports/sales/index'
import { Route as ReportsProductsIndexRouteImport } from './routes/reports/products/index'
import { Route as ReportsOrdersIndexRouteImport } from './routes/reports/orders/index'
import { Route as ReportsLoyaltyIndexRouteImport } from './routes/reports/loyalty/index'
import { Route as ReportsFinancialIndexRouteImport } from './routes/reports/financial/index'
import { Route as ReportsCustomersIndexRouteImport } from './routes/reports/customers/index'
import { Route as ProductsNewIndexRouteImport } from './routes/products/new/index'
import { Route as ProductsBulkEditIndexRouteImport } from './routes/products/bulk-edit/index'
import { Route as ProductsAutomationsIndexRouteImport } from './routes/products/automations/index'
import { Route as ProductsIdIndexRouteImport } from './routes/products/$id/index'
import { Route as PagesNewIndexRouteImport } from './routes/pages/new/index'
import { Route as PagesIdIndexRouteImport } from './routes/pages/$id/index'
import { Route as OrdersShipmentsIndexRouteImport } from './routes/orders/shipments/index'
import { Route as OrdersReturnsIndexRouteImport } from './routes/orders/returns/index'
import { Route as OrdersNewIndexRouteImport } from './routes/orders/new/index'
import { Route as OrdersInvoicesIndexRouteImport } from './routes/orders/invoices/index'
import { Route as OrdersFulfilmentIndexRouteImport } from './routes/orders/fulfilment/index'
import { Route as OrdersDraftsIndexRouteImport } from './routes/orders/drafts/index'
import { Route as OrdersAutomationsIndexRouteImport } from './routes/orders/automations/index'
import { Route as OrdersIdIndexRouteImport } from './routes/orders/$id/index'
import { Route as MarketingSeoIndexRouteImport } from './routes/marketing/seo/index'
import { Route as MarketingSegmentsIndexRouteImport } from './routes/marketing/segments/index'
import { Route as MarketingSalesBoostersIndexRouteImport } from './routes/marketing/sales-boosters/index'
import { Route as MarketingRepurchaseRemindersIndexRouteImport } from './routes/marketing/repurchase-reminders/index'
import { Route as MarketingReferralsIndexRouteImport } from './routes/marketing/referrals/index'
import { Route as MarketingPushNotificationsIndexRouteImport } from './routes/marketing/push-notifications/index'
import { Route as MarketingProductFeedsIndexRouteImport } from './routes/marketing/product-feeds/index'
import { Route as MarketingLoyaltyIndexRouteImport } from './routes/marketing/loyalty/index'
import { Route as MarketingDiscountsIndexRouteImport } from './routes/marketing/discounts/index'
import { Route as MarketingCatalogDiscountsIndexRouteImport } from './routes/marketing/catalog-discounts/index'
import { Route as MarketingCashbackIndexRouteImport } from './routes/marketing/cashback/index'
import { Route as MarketingCalendarIndexRouteImport } from './routes/marketing/calendar/index'
import { Route as MarketingBackInStockIndexRouteImport } from './routes/marketing/back-in-stock/index'
import { Route as MarketingAutomationsIndexRouteImport } from './routes/marketing/automations/index'
import { Route as MarketingAnnouncementsIndexRouteImport } from './routes/marketing/announcements/index'
import { Route as MarketingAffiliatesIndexRouteImport } from './routes/marketing/affiliates/index'
import { Route as MarketingAbandonedCartsIndexRouteImport } from './routes/marketing/abandoned-carts/index'
import { Route as InventoryTransfersIndexRouteImport } from './routes/inventory/transfers/index'
import { Route as InventoryPurchaseOrdersIndexRouteImport } from './routes/inventory/purchase-orders/index'
import { Route as InventoryHistoryIndexRouteImport } from './routes/inventory/history/index'
import { Route as GiftCardsSettingsIndexRouteImport } from './routes/gift-cards/settings/index'
import { Route as GiftCardsIdIndexRouteImport } from './routes/gift-cards/$id/index'
import { Route as FinanceTransactionsIndexRouteImport } from './routes/finance/transactions/index'
import { Route as FiltersNewIndexRouteImport } from './routes/filters/new/index'
import { Route as FiltersIdIndexRouteImport } from './routes/filters/$id/index'
import { Route as FacetsNewIndexRouteImport } from './routes/facets/new/index'
import { Route as FacetsIdIndexRouteImport } from './routes/facets/$id/index'
import { Route as CustomersSmartSegmentsIndexRouteImport } from './routes/customers/smart-segments/index'
import { Route as CustomersRfmIndexRouteImport } from './routes/customers/rfm/index'
import { Route as CustomersReviewsIndexRouteImport } from './routes/customers/reviews/index'
import { Route as CustomersReviewRequestsIndexRouteImport } from './routes/customers/review-requests/index'
import { Route as CustomersQuestionsIndexRouteImport } from './routes/customers/questions/index'
import { Route as CustomersNewIndexRouteImport } from './routes/customers/new/index'
import { Route as CustomersGroupsIndexRouteImport } from './routes/customers/groups/index'
import { Route as CustomersAutomationsIndexRouteImport } from './routes/customers/automations/index'
import { Route as CustomersIdIndexRouteImport } from './routes/customers/$id/index'
import { Route as CollectionsNewIndexRouteImport } from './routes/collections/new/index'
import { Route as CollectionsIdIndexRouteImport } from './routes/collections/$id/index'
import { Route as CategoriesNewIndexRouteImport } from './routes/categories/new/index'
import { Route as CategoriesIdIndexRouteImport } from './routes/categories/$id/index'
import { Route as CatalogLabelsIndexRouteImport } from './routes/catalog/labels/index'
import { Route as BrandsNewIndexRouteImport } from './routes/brands/new/index'
import { Route as BrandsIdIndexRouteImport } from './routes/brands/$id/index'
import { Route as BlogNewIndexRouteImport } from './routes/blog/new/index'
import { Route as BlogCategoriesIndexRouteImport } from './routes/blog/categories/index'
import { Route as BlogIdIndexRouteImport } from './routes/blog/$id/index'
import { Route as AttributesIdIndexRouteImport } from './routes/attributes/$id/index'
import { Route as SettingsStaffInviteIndexRouteImport } from './routes/settings/staff/invite/index'
import { Route as SettingsStaffIdIndexRouteImport } from './routes/settings/staff/$id/index'
import { Route as SettingsShippingManualIndexRouteImport } from './routes/settings/shipping/manual/index'
import { Route as SettingsShippingKaynShipIndexRouteImport } from './routes/settings/shipping/kayn-ship/index'
import { Route as SettingsShippingCarrierCodeIndexRouteImport } from './routes/settings/shipping/$carrierCode/index'
import { Route as SettingsSchedulingIdIndexRouteImport } from './routes/settings/scheduling/$id/index'
import { Route as SettingsPaymentMethodsBankTransferIndexRouteImport } from './routes/settings/payment-methods/bank-transfer/index'
import { Route as SettingsPaymentMethodsActivateIndexRouteImport } from './routes/settings/payment-methods/activate/index'
import { Route as SettingsMetafieldDefinitionsNewIndexRouteImport } from './routes/settings/metafield-definitions/new/index'
import { Route as SettingsMetafieldDefinitionsIdIndexRouteImport } from './routes/settings/metafield-definitions/$id/index'
import { Route as SettingsMessagingWhatsappIndexRouteImport } from './routes/settings/messaging/whatsapp/index'
import { Route as SettingsMessagingLogsIndexRouteImport } from './routes/settings/messaging/logs/index'
import { Route as SettingsBillingPaymentMethodsIndexRouteImport } from './routes/settings/billing/payment-methods/index'
import { Route as SettingsBillingInvoicesIndexRouteImport } from './routes/settings/billing/invoices/index'
import { Route as SettingsBillingAddOnsIndexRouteImport } from './routes/settings/billing/add-ons/index'
import { Route as SettingsAppsAppCodeIndexRouteImport } from './routes/settings/apps/$appCode/index'
import { Route as SalesChannelsOnlineStoreProductExperienceIndexRouteImport } from './routes/sales-channels/online-store/product-experience/index'
import { Route as SalesChannelsOnlineStoreDesignIndexRouteImport } from './routes/sales-channels/online-store/design/index'
import { Route as SalesChannelsMobileAppSettingsIndexRouteImport } from './routes/sales-channels/mobile-app/settings/index'
import { Route as SalesChannelsMobileAppNotificationsIndexRouteImport } from './routes/sales-channels/mobile-app/notifications/index'
import { Route as SalesChannelsMobileAppIdentityIndexRouteImport } from './routes/sales-channels/mobile-app/identity/index'
import { Route as SalesChannelsMobileAppHomepageIndexRouteImport } from './routes/sales-channels/mobile-app/homepage/index'
import { Route as SalesChannelsMobileAppDesignIndexRouteImport } from './routes/sales-channels/mobile-app/design/index'
import { Route as ProductsAutomationsNewIndexRouteImport } from './routes/products/automations/new/index'
import { Route as ProductsAutomationsIdIndexRouteImport } from './routes/products/automations/$id/index'
import { Route as OrdersReturnsIdIndexRouteImport } from './routes/orders/returns/$id/index'
import { Route as OrdersDraftIdIndexRouteImport } from './routes/orders/draft/$id/index'
import { Route as OrdersAutomationsNewIndexRouteImport } from './routes/orders/automations/new/index'
import { Route as OrdersAutomationsIdIndexRouteImport } from './routes/orders/automations/$id/index'
import { Route as OrdersIdModifyIndexRouteImport } from './routes/orders/$id/modify/index'
import { Route as MarketingReferralsSettingsIndexRouteImport } from './routes/marketing/referrals/settings/index'
import { Route as MarketingDiscountsNewIndexRouteImport } from './routes/marketing/discounts/new/index'
import { Route as MarketingDiscountsIdIndexRouteImport } from './routes/marketing/discounts/$id/index'
import { Route as MarketingCatalogDiscountsNewIndexRouteImport } from './routes/marketing/catalog-discounts/new/index'
import { Route as MarketingCatalogDiscountsIdIndexRouteImport } from './routes/marketing/catalog-discounts/$id/index'
import { Route as MarketingCashbackNewIndexRouteImport } from './routes/marketing/cashback/new/index'
import { Route as MarketingCashbackIdIndexRouteImport } from './routes/marketing/cashback/$id/index'
import { Route as MarketingAutomationsSecretsIndexRouteImport } from './routes/marketing/automations/secrets/index'
import { Route as MarketingAutomationsNewIndexRouteImport } from './routes/marketing/automations/new/index'
import { Route as MarketingAutomationsIdIndexRouteImport } from './routes/marketing/automations/$id/index'
import { Route as MarketingAffiliatesSettingsIndexRouteImport } from './routes/marketing/affiliates/settings/index'
import { Route as MarketingAffiliatesNewIndexRouteImport } from './routes/marketing/affiliates/new/index'
import { Route as MarketingAffiliatesIdIndexRouteImport } from './routes/marketing/affiliates/$id/index'
import { Route as InventoryTransfersNewIndexRouteImport } from './routes/inventory/transfers/new/index'
import { Route as InventoryTransfersIdIndexRouteImport } from './routes/inventory/transfers/$id/index'
import { Route as InventoryPurchaseOrdersVendorsIndexRouteImport } from './routes/inventory/purchase-orders/vendors/index'
import { Route as InventoryPurchaseOrdersNewIndexRouteImport } from './routes/inventory/purchase-orders/new/index'
import { Route as InventoryPurchaseOrdersIdIndexRouteImport } from './routes/inventory/purchase-orders/$id/index'
import { Route as CustomersReviewsIdIndexRouteImport } from './routes/customers/reviews/$id/index'
import { Route as CustomersGroupsNewIndexRouteImport } from './routes/customers/groups/new/index'
import { Route as CustomersGroupsIdIndexRouteImport } from './routes/customers/groups/$id/index'
import { Route as CustomersAutomationsNewIndexRouteImport } from './routes/customers/automations/new/index'
import { Route as CustomersAutomationsIdIndexRouteImport } from './routes/customers/automations/$id/index'
import { Route as CustomersIdEditIndexRouteImport } from './routes/customers/$id/edit/index'
import { Route as CatalogLabelsSettingsIndexRouteImport } from './routes/catalog/labels/settings/index'
import { Route as CatalogLabelsNewIndexRouteImport } from './routes/catalog/labels/new/index'
import { Route as CatalogLabelsIdIndexRouteImport } from './routes/catalog/labels/$id/index'
import { Route as SettingsShippingKaynShipWalletIndexRouteImport } from './routes/settings/shipping/kayn-ship/wallet/index'
import { Route as SettingsMessagingWhatsappTemplatesIndexRouteImport } from './routes/settings/messaging/whatsapp/templates/index'
import { Route as ProductsAutomationsIdLogsIndexRouteImport } from './routes/products/automations/$id/logs/index'
import { Route as OrdersAutomationsIdLogsIndexRouteImport } from './routes/orders/automations/$id/logs/index'
import { Route as MarketingAutomationsIdLogsIndexRouteImport } from './routes/marketing/automations/$id/logs/index'
import { Route as InventoryPurchaseOrdersVendorsNewIndexRouteImport } from './routes/inventory/purchase-orders/vendors/new/index'
import { Route as InventoryPurchaseOrdersVendorsIdIndexRouteImport } from './routes/inventory/purchase-orders/vendors/$id/index'
import { Route as CustomersGroupsIdEditIndexRouteImport } from './routes/customers/groups/$id/edit/index'
import { Route as CustomersAutomationsIdLogsIndexRouteImport } from './routes/customers/automations/$id/logs/index'

const ReportsRouteRoute = ReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRouteRoute = FinanceRouteRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const VerifyEmailIndexRoute = VerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/verify-email/index.lazy').then((d) => d.Route),
)
const Verify2faIndexRoute = Verify2faIndexRouteImport.update({
  id: '/verify-2fa/',
  path: '/verify-2fa/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/verify-2fa/index.lazy').then((d) => d.Route),
)
const StockLocationsIndexRoute = StockLocationsIndexRouteImport.update({
  id: '/stock-locations/',
  path: '/stock-locations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/stock-locations/index.lazy').then((d) => d.Route),
)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/signup/index.lazy').then((d) => d.Route))
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/index.lazy').then((d) => d.Route),
)
const SelectStoreIndexRoute = SelectStoreIndexRouteImport.update({
  id: '/select-store/',
  path: '/select-store/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/select-store/index.lazy').then((d) => d.Route),
)
const SalesChannelsIndexRoute = SalesChannelsIndexRouteImport.update({
  id: '/sales-channels/',
  path: '/sales-channels/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/sales-channels/index.lazy').then((d) => d.Route),
)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/reset-password/index.lazy').then((d) => d.Route),
)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReportsRouteRoute,
} as any).lazy(() => import('./routes/reports/index.lazy').then((d) => d.Route))
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/products/index.lazy').then((d) => d.Route),
)
const ProductTemplatesIndexRoute = ProductTemplatesIndexRouteImport.update({
  id: '/product-templates/',
  path: '/product-templates/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/product-templates/index.lazy').then((d) => d.Route),
)
const ProductPropertiesIndexRoute = ProductPropertiesIndexRouteImport.update({
  id: '/product-properties/',
  path: '/product-properties/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/product-properties/index.lazy').then((d) => d.Route),
)
const PagesIndexRoute = PagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/pages/index.lazy').then((d) => d.Route))
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/orders/index.lazy').then((d) => d.Route))
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onboarding/index.lazy').then((d) => d.Route),
)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/notifications/index.lazy').then((d) => d.Route),
)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/marketing/',
  path: '/marketing/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/index.lazy').then((d) => d.Route),
)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login/index.lazy').then((d) => d.Route))
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/inventory/index.lazy').then((d) => d.Route),
)
const GiftCardsIndexRoute = GiftCardsIndexRouteImport.update({
  id: '/gift-cards/',
  path: '/gift-cards/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/gift-cards/index.lazy').then((d) => d.Route),
)
const FinanceIndexRoute = FinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FinanceRouteRoute,
} as any).lazy(() => import('./routes/finance/index.lazy').then((d) => d.Route))
const FiltersIndexRoute = FiltersIndexRouteImport.update({
  id: '/filters/',
  path: '/filters/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/filters/index.lazy').then((d) => d.Route))
const FacetsIndexRoute = FacetsIndexRouteImport.update({
  id: '/facets/',
  path: '/facets/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/facets/index.lazy').then((d) => d.Route))
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/index.lazy').then((d) => d.Route),
)
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/collections/index.lazy').then((d) => d.Route),
)
const CategoriesIndexRoute = CategoriesIndexRouteImport.update({
  id: '/categories/',
  path: '/categories/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/categories/index.lazy').then((d) => d.Route),
)
const CapabilitiesIndexRoute = CapabilitiesIndexRouteImport.update({
  id: '/capabilities/',
  path: '/capabilities/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/capabilities/index.lazy').then((d) => d.Route),
)
const BrandsIndexRoute = BrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/brands/index.lazy').then((d) => d.Route))
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/blog/index.lazy').then((d) => d.Route))
const AttributesIndexRoute = AttributesIndexRouteImport.update({
  id: '/attributes/',
  path: '/attributes/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/attributes/index.lazy').then((d) => d.Route),
)
const AcceptInviteIndexRoute = AcceptInviteIndexRouteImport.update({
  id: '/accept-invite/',
  path: '/accept-invite/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/accept-invite/index.lazy').then((d) => d.Route),
)
const SalesChannelsMobileAppRouteRoute =
  SalesChannelsMobileAppRouteRouteImport.update({
    id: '/sales-channels/mobile-app',
    path: '/sales-channels/mobile-app',
    getParentRoute: () => rootRouteImport,
  } as any)
const StockLocationsNewIndexRoute = StockLocationsNewIndexRouteImport.update({
  id: '/stock-locations/new/',
  path: '/stock-locations/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/stock-locations/new/index.lazy').then((d) => d.Route),
)
const StockLocationsIdIndexRoute = StockLocationsIdIndexRouteImport.update({
  id: '/stock-locations/$id/',
  path: '/stock-locations/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/stock-locations/$id/index.lazy').then((d) => d.Route),
)
const SettingsTestimonialsIndexRoute =
  SettingsTestimonialsIndexRouteImport.update({
    id: '/settings/testimonials/',
    path: '/settings/testimonials/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/testimonials/index.lazy').then((d) => d.Route),
  )
const SettingsTaxIndexRoute = SettingsTaxIndexRouteImport.update({
  id: '/settings/tax/',
  path: '/settings/tax/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/tax/index.lazy').then((d) => d.Route),
)
const SettingsStoreIndexRoute = SettingsStoreIndexRouteImport.update({
  id: '/settings/store/',
  path: '/settings/store/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/store/index.lazy').then((d) => d.Route),
)
const SettingsStaffIndexRoute = SettingsStaffIndexRouteImport.update({
  id: '/settings/staff/',
  path: '/settings/staff/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/staff/index.lazy').then((d) => d.Route),
)
const SettingsShippingIndexRoute = SettingsShippingIndexRouteImport.update({
  id: '/settings/shipping/',
  path: '/settings/shipping/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/shipping/index.lazy').then((d) => d.Route),
)
const SettingsSecurityIndexRoute = SettingsSecurityIndexRouteImport.update({
  id: '/settings/security/',
  path: '/settings/security/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/security/index.lazy').then((d) => d.Route),
)
const SettingsSchedulingIndexRoute = SettingsSchedulingIndexRouteImport.update({
  id: '/settings/scheduling/',
  path: '/settings/scheduling/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/scheduling/index.lazy').then((d) => d.Route),
)
const SettingsReturnPolicyIndexRoute =
  SettingsReturnPolicyIndexRouteImport.update({
    id: '/settings/return-policy/',
    path: '/settings/return-policy/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/return-policy/index.lazy').then((d) => d.Route),
  )
const SettingsProfileIndexRoute = SettingsProfileIndexRouteImport.update({
  id: '/settings/profile/',
  path: '/settings/profile/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/profile/index.lazy').then((d) => d.Route),
)
const SettingsPaymentMethodsIndexRoute =
  SettingsPaymentMethodsIndexRouteImport.update({
    id: '/settings/payment-methods/',
    path: '/settings/payment-methods/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/payment-methods/index.lazy').then((d) => d.Route),
  )
const SettingsOrderCustomizationsIndexRoute =
  SettingsOrderCustomizationsIndexRouteImport.update({
    id: '/settings/order-customizations/',
    path: '/settings/order-customizations/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/order-customizations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsOperationsIndexRoute = SettingsOperationsIndexRouteImport.update({
  id: '/settings/operations/',
  path: '/settings/operations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/operations/index.lazy').then((d) => d.Route),
)
const SettingsNotificationsIndexRoute =
  SettingsNotificationsIndexRouteImport.update({
    id: '/settings/notifications/',
    path: '/settings/notifications/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/notifications/index.lazy').then((d) => d.Route),
  )
const SettingsMetafieldDefinitionsIndexRoute =
  SettingsMetafieldDefinitionsIndexRouteImport.update({
    id: '/settings/metafield-definitions/',
    path: '/settings/metafield-definitions/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/metafield-definitions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsMessagingIndexRoute = SettingsMessagingIndexRouteImport.update({
  id: '/settings/messaging/',
  path: '/settings/messaging/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/messaging/index.lazy').then((d) => d.Route),
)
const SettingsMarketsIndexRoute = SettingsMarketsIndexRouteImport.update({
  id: '/settings/markets/',
  path: '/settings/markets/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/markets/index.lazy').then((d) => d.Route),
)
const SettingsLocalizationIndexRoute =
  SettingsLocalizationIndexRouteImport.update({
    id: '/settings/localization/',
    path: '/settings/localization/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/localization/index.lazy').then((d) => d.Route),
  )
const SettingsLanguagesIndexRoute = SettingsLanguagesIndexRouteImport.update({
  id: '/settings/languages/',
  path: '/settings/languages/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/languages/index.lazy').then((d) => d.Route),
)
const SettingsInvoicesIndexRoute = SettingsInvoicesIndexRouteImport.update({
  id: '/settings/invoices/',
  path: '/settings/invoices/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/invoices/index.lazy').then((d) => d.Route),
)
const SettingsInventoryIndexRoute = SettingsInventoryIndexRouteImport.update({
  id: '/settings/inventory/',
  path: '/settings/inventory/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/inventory/index.lazy').then((d) => d.Route),
)
const SettingsIntegrationsIndexRoute =
  SettingsIntegrationsIndexRouteImport.update({
    id: '/settings/integrations/',
    path: '/settings/integrations/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/integrations/index.lazy').then((d) => d.Route),
  )
const SettingsGiftOptionsIndexRoute =
  SettingsGiftOptionsIndexRouteImport.update({
    id: '/settings/gift-options/',
    path: '/settings/gift-options/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/gift-options/index.lazy').then((d) => d.Route),
  )
const SettingsDomainsIndexRoute = SettingsDomainsIndexRouteImport.update({
  id: '/settings/domains/',
  path: '/settings/domains/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/domains/index.lazy').then((d) => d.Route),
)
const SettingsDataMigrationIndexRoute =
  SettingsDataMigrationIndexRouteImport.update({
    id: '/settings/data-migration/',
    path: '/settings/data-migration/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/data-migration/index.lazy').then((d) => d.Route),
  )
const SettingsContentBlocksIndexRoute =
  SettingsContentBlocksIndexRouteImport.update({
    id: '/settings/content-blocks/',
    path: '/settings/content-blocks/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsCheckoutIndexRoute = SettingsCheckoutIndexRouteImport.update({
  id: '/settings/checkout/',
  path: '/settings/checkout/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/checkout/index.lazy').then((d) => d.Route),
)
const SettingsCheckoutRiskIndexRoute =
  SettingsCheckoutRiskIndexRouteImport.update({
    id: '/settings/checkout-risk/',
    path: '/settings/checkout-risk/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/checkout-risk/index.lazy').then((d) => d.Route),
  )
const SettingsCheckoutRestrictionsIndexRoute =
  SettingsCheckoutRestrictionsIndexRouteImport.update({
    id: '/settings/checkout-restrictions/',
    path: '/settings/checkout-restrictions/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/checkout-restrictions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsBillingIndexRoute = SettingsBillingIndexRouteImport.update({
  id: '/settings/billing/',
  path: '/settings/billing/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/billing/index.lazy').then((d) => d.Route),
)
const SettingsAppsIndexRoute = SettingsAppsIndexRouteImport.update({
  id: '/settings/apps/',
  path: '/settings/apps/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/apps/index.lazy').then((d) => d.Route),
)
const SalesChannelsPosIndexRoute = SalesChannelsPosIndexRouteImport.update({
  id: '/sales-channels/pos/',
  path: '/sales-channels/pos/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/sales-channels/pos/index.lazy').then((d) => d.Route),
)
const SalesChannelsOnlineStoreIndexRoute =
  SalesChannelsOnlineStoreIndexRouteImport.update({
    id: '/sales-channels/online-store/',
    path: '/sales-channels/online-store/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/sales-channels/online-store/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SalesChannelsMobileAppIndexRoute =
  SalesChannelsMobileAppIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SalesChannelsMobileAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/sales-channels/mobile-app/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ReportsSalesIndexRoute = ReportsSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => ReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/reports/sales/index.lazy').then((d) => d.Route),
)
const ReportsProductsIndexRoute = ReportsProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => ReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/reports/products/index.lazy').then((d) => d.Route),
)
const ReportsOrdersIndexRoute = ReportsOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => ReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/reports/orders/index.lazy').then((d) => d.Route),
)
const ReportsLoyaltyIndexRoute = ReportsLoyaltyIndexRouteImport.update({
  id: '/loyalty/',
  path: '/loyalty/',
  getParentRoute: () => ReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/reports/loyalty/index.lazy').then((d) => d.Route),
)
const ReportsFinancialIndexRoute = ReportsFinancialIndexRouteImport.update({
  id: '/financial/',
  path: '/financial/',
  getParentRoute: () => ReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/reports/financial/index.lazy').then((d) => d.Route),
)
const ReportsCustomersIndexRoute = ReportsCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => ReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/reports/customers/index.lazy').then((d) => d.Route),
)
const ProductsNewIndexRoute = ProductsNewIndexRouteImport.update({
  id: '/products/new/',
  path: '/products/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/products/new/index.lazy').then((d) => d.Route),
)
const ProductsBulkEditIndexRoute = ProductsBulkEditIndexRouteImport.update({
  id: '/products/bulk-edit/',
  path: '/products/bulk-edit/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/products/bulk-edit/index.lazy').then((d) => d.Route),
)
const ProductsAutomationsIndexRoute =
  ProductsAutomationsIndexRouteImport.update({
    id: '/products/automations/',
    path: '/products/automations/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/products/automations/index.lazy').then((d) => d.Route),
  )
const ProductsIdIndexRoute = ProductsIdIndexRouteImport.update({
  id: '/products/$id/',
  path: '/products/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/products/$id/index.lazy').then((d) => d.Route),
)
const PagesNewIndexRoute = PagesNewIndexRouteImport.update({
  id: '/pages/new/',
  path: '/pages/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/pages/new/index.lazy').then((d) => d.Route),
)
const PagesIdIndexRoute = PagesIdIndexRouteImport.update({
  id: '/pages/$id/',
  path: '/pages/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/pages/$id/index.lazy').then((d) => d.Route),
)
const OrdersShipmentsIndexRoute = OrdersShipmentsIndexRouteImport.update({
  id: '/orders/shipments/',
  path: '/orders/shipments/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/shipments/index.lazy').then((d) => d.Route),
)
const OrdersReturnsIndexRoute = OrdersReturnsIndexRouteImport.update({
  id: '/orders/returns/',
  path: '/orders/returns/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/returns/index.lazy').then((d) => d.Route),
)
const OrdersNewIndexRoute = OrdersNewIndexRouteImport.update({
  id: '/orders/new/',
  path: '/orders/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/new/index.lazy').then((d) => d.Route),
)
const OrdersInvoicesIndexRoute = OrdersInvoicesIndexRouteImport.update({
  id: '/orders/invoices/',
  path: '/orders/invoices/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/invoices/index.lazy').then((d) => d.Route),
)
const OrdersFulfilmentIndexRoute = OrdersFulfilmentIndexRouteImport.update({
  id: '/orders/fulfilment/',
  path: '/orders/fulfilment/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/fulfilment/index.lazy').then((d) => d.Route),
)
const OrdersDraftsIndexRoute = OrdersDraftsIndexRouteImport.update({
  id: '/orders/drafts/',
  path: '/orders/drafts/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/drafts/index.lazy').then((d) => d.Route),
)
const OrdersAutomationsIndexRoute = OrdersAutomationsIndexRouteImport.update({
  id: '/orders/automations/',
  path: '/orders/automations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/automations/index.lazy').then((d) => d.Route),
)
const OrdersIdIndexRoute = OrdersIdIndexRouteImport.update({
  id: '/orders/$id/',
  path: '/orders/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/$id/index.lazy').then((d) => d.Route),
)
const MarketingSeoIndexRoute = MarketingSeoIndexRouteImport.update({
  id: '/marketing/seo/',
  path: '/marketing/seo/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/seo/index.lazy').then((d) => d.Route),
)
const MarketingSegmentsIndexRoute = MarketingSegmentsIndexRouteImport.update({
  id: '/marketing/segments/',
  path: '/marketing/segments/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/segments/index.lazy').then((d) => d.Route),
)
const MarketingSalesBoostersIndexRoute =
  MarketingSalesBoostersIndexRouteImport.update({
    id: '/marketing/sales-boosters/',
    path: '/marketing/sales-boosters/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/sales-boosters/index.lazy').then((d) => d.Route),
  )
const MarketingRepurchaseRemindersIndexRoute =
  MarketingRepurchaseRemindersIndexRouteImport.update({
    id: '/marketing/repurchase-reminders/',
    path: '/marketing/repurchase-reminders/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/repurchase-reminders/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingReferralsIndexRoute = MarketingReferralsIndexRouteImport.update({
  id: '/marketing/referrals/',
  path: '/marketing/referrals/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/referrals/index.lazy').then((d) => d.Route),
)
const MarketingPushNotificationsIndexRoute =
  MarketingPushNotificationsIndexRouteImport.update({
    id: '/marketing/push-notifications/',
    path: '/marketing/push-notifications/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/push-notifications/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingProductFeedsIndexRoute =
  MarketingProductFeedsIndexRouteImport.update({
    id: '/marketing/product-feeds/',
    path: '/marketing/product-feeds/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/product-feeds/index.lazy').then((d) => d.Route),
  )
const MarketingLoyaltyIndexRoute = MarketingLoyaltyIndexRouteImport.update({
  id: '/marketing/loyalty/',
  path: '/marketing/loyalty/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/loyalty/index.lazy').then((d) => d.Route),
)
const MarketingDiscountsIndexRoute = MarketingDiscountsIndexRouteImport.update({
  id: '/marketing/discounts/',
  path: '/marketing/discounts/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/discounts/index.lazy').then((d) => d.Route),
)
const MarketingCatalogDiscountsIndexRoute =
  MarketingCatalogDiscountsIndexRouteImport.update({
    id: '/marketing/catalog-discounts/',
    path: '/marketing/catalog-discounts/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/catalog-discounts/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingCashbackIndexRoute = MarketingCashbackIndexRouteImport.update({
  id: '/marketing/cashback/',
  path: '/marketing/cashback/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/cashback/index.lazy').then((d) => d.Route),
)
const MarketingCalendarIndexRoute = MarketingCalendarIndexRouteImport.update({
  id: '/marketing/calendar/',
  path: '/marketing/calendar/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/marketing/calendar/index.lazy').then((d) => d.Route),
)
const MarketingBackInStockIndexRoute =
  MarketingBackInStockIndexRouteImport.update({
    id: '/marketing/back-in-stock/',
    path: '/marketing/back-in-stock/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/back-in-stock/index.lazy').then((d) => d.Route),
  )
const MarketingAutomationsIndexRoute =
  MarketingAutomationsIndexRouteImport.update({
    id: '/marketing/automations/',
    path: '/marketing/automations/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/automations/index.lazy').then((d) => d.Route),
  )
const MarketingAnnouncementsIndexRoute =
  MarketingAnnouncementsIndexRouteImport.update({
    id: '/marketing/announcements/',
    path: '/marketing/announcements/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/announcements/index.lazy').then((d) => d.Route),
  )
const MarketingAffiliatesIndexRoute =
  MarketingAffiliatesIndexRouteImport.update({
    id: '/marketing/affiliates/',
    path: '/marketing/affiliates/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/affiliates/index.lazy').then((d) => d.Route),
  )
const MarketingAbandonedCartsIndexRoute =
  MarketingAbandonedCartsIndexRouteImport.update({
    id: '/marketing/abandoned-carts/',
    path: '/marketing/abandoned-carts/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/abandoned-carts/index.lazy').then(
      (d) => d.Route,
    ),
  )
const InventoryTransfersIndexRoute = InventoryTransfersIndexRouteImport.update({
  id: '/inventory/transfers/',
  path: '/inventory/transfers/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/inventory/transfers/index.lazy').then((d) => d.Route),
)
const InventoryPurchaseOrdersIndexRoute =
  InventoryPurchaseOrdersIndexRouteImport.update({
    id: '/inventory/purchase-orders/',
    path: '/inventory/purchase-orders/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/purchase-orders/index.lazy').then(
      (d) => d.Route,
    ),
  )
const InventoryHistoryIndexRoute = InventoryHistoryIndexRouteImport.update({
  id: '/inventory/history/',
  path: '/inventory/history/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/inventory/history/index.lazy').then((d) => d.Route),
)
const GiftCardsSettingsIndexRoute = GiftCardsSettingsIndexRouteImport.update({
  id: '/gift-cards/settings/',
  path: '/gift-cards/settings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/gift-cards/settings/index.lazy').then((d) => d.Route),
)
const GiftCardsIdIndexRoute = GiftCardsIdIndexRouteImport.update({
  id: '/gift-cards/$id/',
  path: '/gift-cards/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/gift-cards/$id/index.lazy').then((d) => d.Route),
)
const FinanceTransactionsIndexRoute =
  FinanceTransactionsIndexRouteImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => FinanceRouteRoute,
  } as any).lazy(() =>
    import('./routes/finance/transactions/index.lazy').then((d) => d.Route),
  )
const FiltersNewIndexRoute = FiltersNewIndexRouteImport.update({
  id: '/filters/new/',
  path: '/filters/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/filters/new/index.lazy').then((d) => d.Route),
)
const FiltersIdIndexRoute = FiltersIdIndexRouteImport.update({
  id: '/filters/$id/',
  path: '/filters/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/filters/$id/index.lazy').then((d) => d.Route),
)
const FacetsNewIndexRoute = FacetsNewIndexRouteImport.update({
  id: '/facets/new/',
  path: '/facets/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/facets/new/index.lazy').then((d) => d.Route),
)
const FacetsIdIndexRoute = FacetsIdIndexRouteImport.update({
  id: '/facets/$id/',
  path: '/facets/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/facets/$id/index.lazy').then((d) => d.Route),
)
const CustomersSmartSegmentsIndexRoute =
  CustomersSmartSegmentsIndexRouteImport.update({
    id: '/customers/smart-segments/',
    path: '/customers/smart-segments/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/customers/smart-segments/index.lazy').then((d) => d.Route),
  )
const CustomersRfmIndexRoute = CustomersRfmIndexRouteImport.update({
  id: '/customers/rfm/',
  path: '/customers/rfm/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/rfm/index.lazy').then((d) => d.Route),
)
const CustomersReviewsIndexRoute = CustomersReviewsIndexRouteImport.update({
  id: '/customers/reviews/',
  path: '/customers/reviews/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/reviews/index.lazy').then((d) => d.Route),
)
const CustomersReviewRequestsIndexRoute =
  CustomersReviewRequestsIndexRouteImport.update({
    id: '/customers/review-requests/',
    path: '/customers/review-requests/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/customers/review-requests/index.lazy').then(
      (d) => d.Route,
    ),
  )
const CustomersQuestionsIndexRoute = CustomersQuestionsIndexRouteImport.update({
  id: '/customers/questions/',
  path: '/customers/questions/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/questions/index.lazy').then((d) => d.Route),
)
const CustomersNewIndexRoute = CustomersNewIndexRouteImport.update({
  id: '/customers/new/',
  path: '/customers/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/new/index.lazy').then((d) => d.Route),
)
const CustomersGroupsIndexRoute = CustomersGroupsIndexRouteImport.update({
  id: '/customers/groups/',
  path: '/customers/groups/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/groups/index.lazy').then((d) => d.Route),
)
const CustomersAutomationsIndexRoute =
  CustomersAutomationsIndexRouteImport.update({
    id: '/customers/automations/',
    path: '/customers/automations/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/customers/automations/index.lazy').then((d) => d.Route),
  )
const CustomersIdIndexRoute = CustomersIdIndexRouteImport.update({
  id: '/customers/$id/',
  path: '/customers/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/$id/index.lazy').then((d) => d.Route),
)
const CollectionsNewIndexRoute = CollectionsNewIndexRouteImport.update({
  id: '/collections/new/',
  path: '/collections/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/collections/new/index.lazy').then((d) => d.Route),
)
const CollectionsIdIndexRoute = CollectionsIdIndexRouteImport.update({
  id: '/collections/$id/',
  path: '/collections/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/collections/$id/index.lazy').then((d) => d.Route),
)
const CategoriesNewIndexRoute = CategoriesNewIndexRouteImport.update({
  id: '/categories/new/',
  path: '/categories/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/categories/new/index.lazy').then((d) => d.Route),
)
const CategoriesIdIndexRoute = CategoriesIdIndexRouteImport.update({
  id: '/categories/$id/',
  path: '/categories/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/categories/$id/index.lazy').then((d) => d.Route),
)
const CatalogLabelsIndexRoute = CatalogLabelsIndexRouteImport.update({
  id: '/catalog/labels/',
  path: '/catalog/labels/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/catalog/labels/index.lazy').then((d) => d.Route),
)
const BrandsNewIndexRoute = BrandsNewIndexRouteImport.update({
  id: '/brands/new/',
  path: '/brands/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/brands/new/index.lazy').then((d) => d.Route),
)
const BrandsIdIndexRoute = BrandsIdIndexRouteImport.update({
  id: '/brands/$id/',
  path: '/brands/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/brands/$id/index.lazy').then((d) => d.Route),
)
const BlogNewIndexRoute = BlogNewIndexRouteImport.update({
  id: '/blog/new/',
  path: '/blog/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/blog/new/index.lazy').then((d) => d.Route),
)
const BlogCategoriesIndexRoute = BlogCategoriesIndexRouteImport.update({
  id: '/blog/categories/',
  path: '/blog/categories/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/blog/categories/index.lazy').then((d) => d.Route),
)
const BlogIdIndexRoute = BlogIdIndexRouteImport.update({
  id: '/blog/$id/',
  path: '/blog/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/blog/$id/index.lazy').then((d) => d.Route),
)
const AttributesIdIndexRoute = AttributesIdIndexRouteImport.update({
  id: '/attributes/$id/',
  path: '/attributes/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/attributes/$id/index.lazy').then((d) => d.Route),
)
const SettingsStaffInviteIndexRoute =
  SettingsStaffInviteIndexRouteImport.update({
    id: '/settings/staff/invite/',
    path: '/settings/staff/invite/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/staff/invite/index.lazy').then((d) => d.Route),
  )
const SettingsStaffIdIndexRoute = SettingsStaffIdIndexRouteImport.update({
  id: '/settings/staff/$id/',
  path: '/settings/staff/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/staff/$id/index.lazy').then((d) => d.Route),
)
const SettingsShippingManualIndexRoute =
  SettingsShippingManualIndexRouteImport.update({
    id: '/settings/shipping/manual/',
    path: '/settings/shipping/manual/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/shipping/manual/index.lazy').then((d) => d.Route),
  )
const SettingsShippingKaynShipIndexRoute =
  SettingsShippingKaynShipIndexRouteImport.update({
    id: '/settings/shipping/kayn-ship/',
    path: '/settings/shipping/kayn-ship/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/shipping/kayn-ship/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsShippingCarrierCodeIndexRoute =
  SettingsShippingCarrierCodeIndexRouteImport.update({
    id: '/settings/shipping/$carrierCode/',
    path: '/settings/shipping/$carrierCode/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/shipping/$carrierCode/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsSchedulingIdIndexRoute =
  SettingsSchedulingIdIndexRouteImport.update({
    id: '/settings/scheduling/$id/',
    path: '/settings/scheduling/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/scheduling/$id/index.lazy').then((d) => d.Route),
  )
const SettingsPaymentMethodsBankTransferIndexRoute =
  SettingsPaymentMethodsBankTransferIndexRouteImport.update({
    id: '/settings/payment-methods/bank-transfer/',
    path: '/settings/payment-methods/bank-transfer/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/payment-methods/bank-transfer/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsPaymentMethodsActivateIndexRoute =
  SettingsPaymentMethodsActivateIndexRouteImport.update({
    id: '/settings/payment-methods/activate/',
    path: '/settings/payment-methods/activate/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/payment-methods/activate/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsMetafieldDefinitionsNewIndexRoute =
  SettingsMetafieldDefinitionsNewIndexRouteImport.update({
    id: '/settings/metafield-definitions/new/',
    path: '/settings/metafield-definitions/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/metafield-definitions/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsMetafieldDefinitionsIdIndexRoute =
  SettingsMetafieldDefinitionsIdIndexRouteImport.update({
    id: '/settings/metafield-definitions/$id/',
    path: '/settings/metafield-definitions/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/metafield-definitions/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsMessagingWhatsappIndexRoute =
  SettingsMessagingWhatsappIndexRouteImport.update({
    id: '/settings/messaging/whatsapp/',
    path: '/settings/messaging/whatsapp/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/messaging/whatsapp/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsMessagingLogsIndexRoute =
  SettingsMessagingLogsIndexRouteImport.update({
    id: '/settings/messaging/logs/',
    path: '/settings/messaging/logs/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/messaging/logs/index.lazy').then((d) => d.Route),
  )
const SettingsBillingPaymentMethodsIndexRoute =
  SettingsBillingPaymentMethodsIndexRouteImport.update({
    id: '/settings/billing/payment-methods/',
    path: '/settings/billing/payment-methods/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/billing/payment-methods/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsBillingInvoicesIndexRoute =
  SettingsBillingInvoicesIndexRouteImport.update({
    id: '/settings/billing/invoices/',
    path: '/settings/billing/invoices/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/billing/invoices/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsBillingAddOnsIndexRoute =
  SettingsBillingAddOnsIndexRouteImport.update({
    id: '/settings/billing/add-ons/',
    path: '/settings/billing/add-ons/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/billing/add-ons/index.lazy').then((d) => d.Route),
  )
const SettingsAppsAppCodeIndexRoute =
  SettingsAppsAppCodeIndexRouteImport.update({
    id: '/settings/apps/$appCode/',
    path: '/settings/apps/$appCode/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/apps/$appCode/index.lazy').then((d) => d.Route),
  )
const SalesChannelsOnlineStoreProductExperienceIndexRoute =
  SalesChannelsOnlineStoreProductExperienceIndexRouteImport.update({
    id: '/sales-channels/online-store/product-experience/',
    path: '/sales-channels/online-store/product-experience/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/sales-channels/online-store/product-experience/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SalesChannelsOnlineStoreDesignIndexRoute =
  SalesChannelsOnlineStoreDesignIndexRouteImport.update({
    id: '/sales-channels/online-store/design/',
    path: '/sales-channels/online-store/design/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/sales-channels/online-store/design/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SalesChannelsMobileAppSettingsIndexRoute =
  SalesChannelsMobileAppSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => SalesChannelsMobileAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/sales-channels/mobile-app/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SalesChannelsMobileAppNotificationsIndexRoute =
  SalesChannelsMobileAppNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => SalesChannelsMobileAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/sales-channels/mobile-app/notifications/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SalesChannelsMobileAppIdentityIndexRoute =
  SalesChannelsMobileAppIdentityIndexRouteImport.update({
    id: '/identity/',
    path: '/identity/',
    getParentRoute: () => SalesChannelsMobileAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/sales-channels/mobile-app/identity/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SalesChannelsMobileAppHomepageIndexRoute =
  SalesChannelsMobileAppHomepageIndexRouteImport.update({
    id: '/homepage/',
    path: '/homepage/',
    getParentRoute: () => SalesChannelsMobileAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/sales-channels/mobile-app/homepage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SalesChannelsMobileAppDesignIndexRoute =
  SalesChannelsMobileAppDesignIndexRouteImport.update({
    id: '/design/',
    path: '/design/',
    getParentRoute: () => SalesChannelsMobileAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/sales-channels/mobile-app/design/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProductsAutomationsNewIndexRoute =
  ProductsAutomationsNewIndexRouteImport.update({
    id: '/products/automations/new/',
    path: '/products/automations/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/products/automations/new/index.lazy').then((d) => d.Route),
  )
const ProductsAutomationsIdIndexRoute =
  ProductsAutomationsIdIndexRouteImport.update({
    id: '/products/automations/$id/',
    path: '/products/automations/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/products/automations/$id/index.lazy').then((d) => d.Route),
  )
const OrdersReturnsIdIndexRoute = OrdersReturnsIdIndexRouteImport.update({
  id: '/orders/returns/$id/',
  path: '/orders/returns/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/returns/$id/index.lazy').then((d) => d.Route),
)
const OrdersDraftIdIndexRoute = OrdersDraftIdIndexRouteImport.update({
  id: '/orders/draft/$id/',
  path: '/orders/draft/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/draft/$id/index.lazy').then((d) => d.Route),
)
const OrdersAutomationsNewIndexRoute =
  OrdersAutomationsNewIndexRouteImport.update({
    id: '/orders/automations/new/',
    path: '/orders/automations/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/orders/automations/new/index.lazy').then((d) => d.Route),
  )
const OrdersAutomationsIdIndexRoute =
  OrdersAutomationsIdIndexRouteImport.update({
    id: '/orders/automations/$id/',
    path: '/orders/automations/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/orders/automations/$id/index.lazy').then((d) => d.Route),
  )
const OrdersIdModifyIndexRoute = OrdersIdModifyIndexRouteImport.update({
  id: '/orders/$id/modify/',
  path: '/orders/$id/modify/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/orders/$id/modify/index.lazy').then((d) => d.Route),
)
const MarketingReferralsSettingsIndexRoute =
  MarketingReferralsSettingsIndexRouteImport.update({
    id: '/marketing/referrals/settings/',
    path: '/marketing/referrals/settings/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/referrals/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingDiscountsNewIndexRoute =
  MarketingDiscountsNewIndexRouteImport.update({
    id: '/marketing/discounts/new/',
    path: '/marketing/discounts/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/discounts/new/index.lazy').then((d) => d.Route),
  )
const MarketingDiscountsIdIndexRoute =
  MarketingDiscountsIdIndexRouteImport.update({
    id: '/marketing/discounts/$id/',
    path: '/marketing/discounts/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/discounts/$id/index.lazy').then((d) => d.Route),
  )
const MarketingCatalogDiscountsNewIndexRoute =
  MarketingCatalogDiscountsNewIndexRouteImport.update({
    id: '/marketing/catalog-discounts/new/',
    path: '/marketing/catalog-discounts/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/catalog-discounts/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingCatalogDiscountsIdIndexRoute =
  MarketingCatalogDiscountsIdIndexRouteImport.update({
    id: '/marketing/catalog-discounts/$id/',
    path: '/marketing/catalog-discounts/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/catalog-discounts/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingCashbackNewIndexRoute =
  MarketingCashbackNewIndexRouteImport.update({
    id: '/marketing/cashback/new/',
    path: '/marketing/cashback/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/cashback/new/index.lazy').then((d) => d.Route),
  )
const MarketingCashbackIdIndexRoute =
  MarketingCashbackIdIndexRouteImport.update({
    id: '/marketing/cashback/$id/',
    path: '/marketing/cashback/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/cashback/$id/index.lazy').then((d) => d.Route),
  )
const MarketingAutomationsSecretsIndexRoute =
  MarketingAutomationsSecretsIndexRouteImport.update({
    id: '/marketing/automations/secrets/',
    path: '/marketing/automations/secrets/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/automations/secrets/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingAutomationsNewIndexRoute =
  MarketingAutomationsNewIndexRouteImport.update({
    id: '/marketing/automations/new/',
    path: '/marketing/automations/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/automations/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingAutomationsIdIndexRoute =
  MarketingAutomationsIdIndexRouteImport.update({
    id: '/marketing/automations/$id/',
    path: '/marketing/automations/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/automations/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingAffiliatesSettingsIndexRoute =
  MarketingAffiliatesSettingsIndexRouteImport.update({
    id: '/marketing/affiliates/settings/',
    path: '/marketing/affiliates/settings/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/affiliates/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingAffiliatesNewIndexRoute =
  MarketingAffiliatesNewIndexRouteImport.update({
    id: '/marketing/affiliates/new/',
    path: '/marketing/affiliates/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/affiliates/new/index.lazy').then((d) => d.Route),
  )
const MarketingAffiliatesIdIndexRoute =
  MarketingAffiliatesIdIndexRouteImport.update({
    id: '/marketing/affiliates/$id/',
    path: '/marketing/affiliates/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/affiliates/$id/index.lazy').then((d) => d.Route),
  )
const InventoryTransfersNewIndexRoute =
  InventoryTransfersNewIndexRouteImport.update({
    id: '/inventory/transfers/new/',
    path: '/inventory/transfers/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/transfers/new/index.lazy').then((d) => d.Route),
  )
const InventoryTransfersIdIndexRoute =
  InventoryTransfersIdIndexRouteImport.update({
    id: '/inventory/transfers/$id/',
    path: '/inventory/transfers/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/transfers/$id/index.lazy').then((d) => d.Route),
  )
const InventoryPurchaseOrdersVendorsIndexRoute =
  InventoryPurchaseOrdersVendorsIndexRouteImport.update({
    id: '/inventory/purchase-orders/vendors/',
    path: '/inventory/purchase-orders/vendors/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/purchase-orders/vendors/index.lazy').then(
      (d) => d.Route,
    ),
  )
const InventoryPurchaseOrdersNewIndexRoute =
  InventoryPurchaseOrdersNewIndexRouteImport.update({
    id: '/inventory/purchase-orders/new/',
    path: '/inventory/purchase-orders/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/purchase-orders/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const InventoryPurchaseOrdersIdIndexRoute =
  InventoryPurchaseOrdersIdIndexRouteImport.update({
    id: '/inventory/purchase-orders/$id/',
    path: '/inventory/purchase-orders/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/purchase-orders/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const CustomersReviewsIdIndexRoute = CustomersReviewsIdIndexRouteImport.update({
  id: '/customers/reviews/$id/',
  path: '/customers/reviews/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/reviews/$id/index.lazy').then((d) => d.Route),
)
const CustomersGroupsNewIndexRoute = CustomersGroupsNewIndexRouteImport.update({
  id: '/customers/groups/new/',
  path: '/customers/groups/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/groups/new/index.lazy').then((d) => d.Route),
)
const CustomersGroupsIdIndexRoute = CustomersGroupsIdIndexRouteImport.update({
  id: '/customers/groups/$id/',
  path: '/customers/groups/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/groups/$id/index.lazy').then((d) => d.Route),
)
const CustomersAutomationsNewIndexRoute =
  CustomersAutomationsNewIndexRouteImport.update({
    id: '/customers/automations/new/',
    path: '/customers/automations/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/customers/automations/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const CustomersAutomationsIdIndexRoute =
  CustomersAutomationsIdIndexRouteImport.update({
    id: '/customers/automations/$id/',
    path: '/customers/automations/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/customers/automations/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const CustomersIdEditIndexRoute = CustomersIdEditIndexRouteImport.update({
  id: '/customers/$id/edit/',
  path: '/customers/$id/edit/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/customers/$id/edit/index.lazy').then((d) => d.Route),
)
const CatalogLabelsSettingsIndexRoute =
  CatalogLabelsSettingsIndexRouteImport.update({
    id: '/catalog/labels/settings/',
    path: '/catalog/labels/settings/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/catalog/labels/settings/index.lazy').then((d) => d.Route),
  )
const CatalogLabelsNewIndexRoute = CatalogLabelsNewIndexRouteImport.update({
  id: '/catalog/labels/new/',
  path: '/catalog/labels/new/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/catalog/labels/new/index.lazy').then((d) => d.Route),
)
const CatalogLabelsIdIndexRoute = CatalogLabelsIdIndexRouteImport.update({
  id: '/catalog/labels/$id/',
  path: '/catalog/labels/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/catalog/labels/$id/index.lazy').then((d) => d.Route),
)
const SettingsShippingKaynShipWalletIndexRoute =
  SettingsShippingKaynShipWalletIndexRouteImport.update({
    id: '/settings/shipping/kayn-ship/wallet/',
    path: '/settings/shipping/kayn-ship/wallet/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/shipping/kayn-ship/wallet/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SettingsMessagingWhatsappTemplatesIndexRoute =
  SettingsMessagingWhatsappTemplatesIndexRouteImport.update({
    id: '/settings/messaging/whatsapp/templates/',
    path: '/settings/messaging/whatsapp/templates/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/settings/messaging/whatsapp/templates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProductsAutomationsIdLogsIndexRoute =
  ProductsAutomationsIdLogsIndexRouteImport.update({
    id: '/products/automations/$id/logs/',
    path: '/products/automations/$id/logs/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/products/automations/$id/logs/index.lazy').then(
      (d) => d.Route,
    ),
  )
const OrdersAutomationsIdLogsIndexRoute =
  OrdersAutomationsIdLogsIndexRouteImport.update({
    id: '/orders/automations/$id/logs/',
    path: '/orders/automations/$id/logs/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/orders/automations/$id/logs/index.lazy').then(
      (d) => d.Route,
    ),
  )
const MarketingAutomationsIdLogsIndexRoute =
  MarketingAutomationsIdLogsIndexRouteImport.update({
    id: '/marketing/automations/$id/logs/',
    path: '/marketing/automations/$id/logs/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/marketing/automations/$id/logs/index.lazy').then(
      (d) => d.Route,
    ),
  )
const InventoryPurchaseOrdersVendorsNewIndexRoute =
  InventoryPurchaseOrdersVendorsNewIndexRouteImport.update({
    id: '/inventory/purchase-orders/vendors/new/',
    path: '/inventory/purchase-orders/vendors/new/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/purchase-orders/vendors/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const InventoryPurchaseOrdersVendorsIdIndexRoute =
  InventoryPurchaseOrdersVendorsIdIndexRouteImport.update({
    id: '/inventory/purchase-orders/vendors/$id/',
    path: '/inventory/purchase-orders/vendors/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/inventory/purchase-orders/vendors/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const CustomersGroupsIdEditIndexRoute =
  CustomersGroupsIdEditIndexRouteImport.update({
    id: '/customers/groups/$id/edit/',
    path: '/customers/groups/$id/edit/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/customers/groups/$id/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )
const CustomersAutomationsIdLogsIndexRoute =
  CustomersAutomationsIdLogsIndexRouteImport.update({
    id: '/customers/automations/$id/logs/',
    path: '/customers/automations/$id/logs/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/customers/automations/$id/logs/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/finance': typeof FinanceRouteRouteWithChildren
  '/reports': typeof ReportsRouteRouteWithChildren
  '/sales-channels/mobile-app': typeof SalesChannelsMobileAppRouteRouteWithChildren
  '/accept-invite/': typeof AcceptInviteIndexRoute
  '/attributes/': typeof AttributesIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/capabilities/': typeof CapabilitiesIndexRoute
  '/categories/': typeof CategoriesIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/facets/': typeof FacetsIndexRoute
  '/filters/': typeof FiltersIndexRoute
  '/finance/': typeof FinanceIndexRoute
  '/gift-cards/': typeof GiftCardsIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/login/': typeof LoginIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/pages/': typeof PagesIndexRoute
  '/product-properties/': typeof ProductPropertiesIndexRoute
  '/product-templates/': typeof ProductTemplatesIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/sales-channels/': typeof SalesChannelsIndexRoute
  '/select-store/': typeof SelectStoreIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/stock-locations/': typeof StockLocationsIndexRoute
  '/verify-2fa/': typeof Verify2faIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/attributes/$id/': typeof AttributesIdIndexRoute
  '/blog/$id/': typeof BlogIdIndexRoute
  '/blog/categories/': typeof BlogCategoriesIndexRoute
  '/blog/new/': typeof BlogNewIndexRoute
  '/brands/$id/': typeof BrandsIdIndexRoute
  '/brands/new/': typeof BrandsNewIndexRoute
  '/catalog/labels/': typeof CatalogLabelsIndexRoute
  '/categories/$id/': typeof CategoriesIdIndexRoute
  '/categories/new/': typeof CategoriesNewIndexRoute
  '/collections/$id/': typeof CollectionsIdIndexRoute
  '/collections/new/': typeof CollectionsNewIndexRoute
  '/customers/$id/': typeof CustomersIdIndexRoute
  '/customers/automations/': typeof CustomersAutomationsIndexRoute
  '/customers/groups/': typeof CustomersGroupsIndexRoute
  '/customers/new/': typeof CustomersNewIndexRoute
  '/customers/questions/': typeof CustomersQuestionsIndexRoute
  '/customers/review-requests/': typeof CustomersReviewRequestsIndexRoute
  '/customers/reviews/': typeof CustomersReviewsIndexRoute
  '/customers/rfm/': typeof CustomersRfmIndexRoute
  '/customers/smart-segments/': typeof CustomersSmartSegmentsIndexRoute
  '/facets/$id/': typeof FacetsIdIndexRoute
  '/facets/new/': typeof FacetsNewIndexRoute
  '/filters/$id/': typeof FiltersIdIndexRoute
  '/filters/new/': typeof FiltersNewIndexRoute
  '/finance/transactions/': typeof FinanceTransactionsIndexRoute
  '/gift-cards/$id/': typeof GiftCardsIdIndexRoute
  '/gift-cards/settings/': typeof GiftCardsSettingsIndexRoute
  '/inventory/history/': typeof InventoryHistoryIndexRoute
  '/inventory/purchase-orders/': typeof InventoryPurchaseOrdersIndexRoute
  '/inventory/transfers/': typeof InventoryTransfersIndexRoute
  '/marketing/abandoned-carts/': typeof MarketingAbandonedCartsIndexRoute
  '/marketing/affiliates/': typeof MarketingAffiliatesIndexRoute
  '/marketing/announcements/': typeof MarketingAnnouncementsIndexRoute
  '/marketing/automations/': typeof MarketingAutomationsIndexRoute
  '/marketing/back-in-stock/': typeof MarketingBackInStockIndexRoute
  '/marketing/calendar/': typeof MarketingCalendarIndexRoute
  '/marketing/cashback/': typeof MarketingCashbackIndexRoute
  '/marketing/catalog-discounts/': typeof MarketingCatalogDiscountsIndexRoute
  '/marketing/discounts/': typeof MarketingDiscountsIndexRoute
  '/marketing/loyalty/': typeof MarketingLoyaltyIndexRoute
  '/marketing/product-feeds/': typeof MarketingProductFeedsIndexRoute
  '/marketing/push-notifications/': typeof MarketingPushNotificationsIndexRoute
  '/marketing/referrals/': typeof MarketingReferralsIndexRoute
  '/marketing/repurchase-reminders/': typeof MarketingRepurchaseRemindersIndexRoute
  '/marketing/sales-boosters/': typeof MarketingSalesBoostersIndexRoute
  '/marketing/segments/': typeof MarketingSegmentsIndexRoute
  '/marketing/seo/': typeof MarketingSeoIndexRoute
  '/orders/$id/': typeof OrdersIdIndexRoute
  '/orders/automations/': typeof OrdersAutomationsIndexRoute
  '/orders/drafts/': typeof OrdersDraftsIndexRoute
  '/orders/fulfilment/': typeof OrdersFulfilmentIndexRoute
  '/orders/invoices/': typeof OrdersInvoicesIndexRoute
  '/orders/new/': typeof OrdersNewIndexRoute
  '/orders/returns/': typeof OrdersReturnsIndexRoute
  '/orders/shipments/': typeof OrdersShipmentsIndexRoute
  '/pages/$id/': typeof PagesIdIndexRoute
  '/pages/new/': typeof PagesNewIndexRoute
  '/products/$id/': typeof ProductsIdIndexRoute
  '/products/automations/': typeof ProductsAutomationsIndexRoute
  '/products/bulk-edit/': typeof ProductsBulkEditIndexRoute
  '/products/new/': typeof ProductsNewIndexRoute
  '/reports/customers/': typeof ReportsCustomersIndexRoute
  '/reports/financial/': typeof ReportsFinancialIndexRoute
  '/reports/loyalty/': typeof ReportsLoyaltyIndexRoute
  '/reports/orders/': typeof ReportsOrdersIndexRoute
  '/reports/products/': typeof ReportsProductsIndexRoute
  '/reports/sales/': typeof ReportsSalesIndexRoute
  '/sales-channels/mobile-app/': typeof SalesChannelsMobileAppIndexRoute
  '/sales-channels/online-store/': typeof SalesChannelsOnlineStoreIndexRoute
  '/sales-channels/pos/': typeof SalesChannelsPosIndexRoute
  '/settings/apps/': typeof SettingsAppsIndexRoute
  '/settings/billing/': typeof SettingsBillingIndexRoute
  '/settings/checkout-restrictions/': typeof SettingsCheckoutRestrictionsIndexRoute
  '/settings/checkout-risk/': typeof SettingsCheckoutRiskIndexRoute
  '/settings/checkout/': typeof SettingsCheckoutIndexRoute
  '/settings/content-blocks/': typeof SettingsContentBlocksIndexRoute
  '/settings/data-migration/': typeof SettingsDataMigrationIndexRoute
  '/settings/domains/': typeof SettingsDomainsIndexRoute
  '/settings/gift-options/': typeof SettingsGiftOptionsIndexRoute
  '/settings/integrations/': typeof SettingsIntegrationsIndexRoute
  '/settings/inventory/': typeof SettingsInventoryIndexRoute
  '/settings/invoices/': typeof SettingsInvoicesIndexRoute
  '/settings/languages/': typeof SettingsLanguagesIndexRoute
  '/settings/localization/': typeof SettingsLocalizationIndexRoute
  '/settings/markets/': typeof SettingsMarketsIndexRoute
  '/settings/messaging/': typeof SettingsMessagingIndexRoute
  '/settings/metafield-definitions/': typeof SettingsMetafieldDefinitionsIndexRoute
  '/settings/notifications/': typeof SettingsNotificationsIndexRoute
  '/settings/operations/': typeof SettingsOperationsIndexRoute
  '/settings/order-customizations/': typeof SettingsOrderCustomizationsIndexRoute
  '/settings/payment-methods/': typeof SettingsPaymentMethodsIndexRoute
  '/settings/profile/': typeof SettingsProfileIndexRoute
  '/settings/return-policy/': typeof SettingsReturnPolicyIndexRoute
  '/settings/scheduling/': typeof SettingsSchedulingIndexRoute
  '/settings/security/': typeof SettingsSecurityIndexRoute
  '/settings/shipping/': typeof SettingsShippingIndexRoute
  '/settings/staff/': typeof SettingsStaffIndexRoute
  '/settings/store/': typeof SettingsStoreIndexRoute
  '/settings/tax/': typeof SettingsTaxIndexRoute
  '/settings/testimonials/': typeof SettingsTestimonialsIndexRoute
  '/stock-locations/$id/': typeof StockLocationsIdIndexRoute
  '/stock-locations/new/': typeof StockLocationsNewIndexRoute
  '/catalog/labels/$id/': typeof CatalogLabelsIdIndexRoute
  '/catalog/labels/new/': typeof CatalogLabelsNewIndexRoute
  '/catalog/labels/settings/': typeof CatalogLabelsSettingsIndexRoute
  '/customers/$id/edit/': typeof CustomersIdEditIndexRoute
  '/customers/automations/$id/': typeof CustomersAutomationsIdIndexRoute
  '/customers/automations/new/': typeof CustomersAutomationsNewIndexRoute
  '/customers/groups/$id/': typeof CustomersGroupsIdIndexRoute
  '/customers/groups/new/': typeof CustomersGroupsNewIndexRoute
  '/customers/reviews/$id/': typeof CustomersReviewsIdIndexRoute
  '/inventory/purchase-orders/$id/': typeof InventoryPurchaseOrdersIdIndexRoute
  '/inventory/purchase-orders/new/': typeof InventoryPurchaseOrdersNewIndexRoute
  '/inventory/purchase-orders/vendors/': typeof InventoryPurchaseOrdersVendorsIndexRoute
  '/inventory/transfers/$id/': typeof InventoryTransfersIdIndexRoute
  '/inventory/transfers/new/': typeof InventoryTransfersNewIndexRoute
  '/marketing/affiliates/$id/': typeof MarketingAffiliatesIdIndexRoute
  '/marketing/affiliates/new/': typeof MarketingAffiliatesNewIndexRoute
  '/marketing/affiliates/settings/': typeof MarketingAffiliatesSettingsIndexRoute
  '/marketing/automations/$id/': typeof MarketingAutomationsIdIndexRoute
  '/marketing/automations/new/': typeof MarketingAutomationsNewIndexRoute
  '/marketing/automations/secrets/': typeof MarketingAutomationsSecretsIndexRoute
  '/marketing/cashback/$id/': typeof MarketingCashbackIdIndexRoute
  '/marketing/cashback/new/': typeof MarketingCashbackNewIndexRoute
  '/marketing/catalog-discounts/$id/': typeof MarketingCatalogDiscountsIdIndexRoute
  '/marketing/catalog-discounts/new/': typeof MarketingCatalogDiscountsNewIndexRoute
  '/marketing/discounts/$id/': typeof MarketingDiscountsIdIndexRoute
  '/marketing/discounts/new/': typeof MarketingDiscountsNewIndexRoute
  '/marketing/referrals/settings/': typeof MarketingReferralsSettingsIndexRoute
  '/orders/$id/modify/': typeof OrdersIdModifyIndexRoute
  '/orders/automations/$id/': typeof OrdersAutomationsIdIndexRoute
  '/orders/automations/new/': typeof OrdersAutomationsNewIndexRoute
  '/orders/draft/$id/': typeof OrdersDraftIdIndexRoute
  '/orders/returns/$id/': typeof OrdersReturnsIdIndexRoute
  '/products/automations/$id/': typeof ProductsAutomationsIdIndexRoute
  '/products/automations/new/': typeof ProductsAutomationsNewIndexRoute
  '/sales-channels/mobile-app/design/': typeof SalesChannelsMobileAppDesignIndexRoute
  '/sales-channels/mobile-app/homepage/': typeof SalesChannelsMobileAppHomepageIndexRoute
  '/sales-channels/mobile-app/identity/': typeof SalesChannelsMobileAppIdentityIndexRoute
  '/sales-channels/mobile-app/notifications/': typeof SalesChannelsMobileAppNotificationsIndexRoute
  '/sales-channels/mobile-app/settings/': typeof SalesChannelsMobileAppSettingsIndexRoute
  '/sales-channels/online-store/design/': typeof SalesChannelsOnlineStoreDesignIndexRoute
  '/sales-channels/online-store/product-experience/': typeof SalesChannelsOnlineStoreProductExperienceIndexRoute
  '/settings/apps/$appCode/': typeof SettingsAppsAppCodeIndexRoute
  '/settings/billing/add-ons/': typeof SettingsBillingAddOnsIndexRoute
  '/settings/billing/invoices/': typeof SettingsBillingInvoicesIndexRoute
  '/settings/billing/payment-methods/': typeof SettingsBillingPaymentMethodsIndexRoute
  '/settings/messaging/logs/': typeof SettingsMessagingLogsIndexRoute
  '/settings/messaging/whatsapp/': typeof SettingsMessagingWhatsappIndexRoute
  '/settings/metafield-definitions/$id/': typeof SettingsMetafieldDefinitionsIdIndexRoute
  '/settings/metafield-definitions/new/': typeof SettingsMetafieldDefinitionsNewIndexRoute
  '/settings/payment-methods/activate/': typeof SettingsPaymentMethodsActivateIndexRoute
  '/settings/payment-methods/bank-transfer/': typeof SettingsPaymentMethodsBankTransferIndexRoute
  '/settings/scheduling/$id/': typeof SettingsSchedulingIdIndexRoute
  '/settings/shipping/$carrierCode/': typeof SettingsShippingCarrierCodeIndexRoute
  '/settings/shipping/kayn-ship/': typeof SettingsShippingKaynShipIndexRoute
  '/settings/shipping/manual/': typeof SettingsShippingManualIndexRoute
  '/settings/staff/$id/': typeof SettingsStaffIdIndexRoute
  '/settings/staff/invite/': typeof SettingsStaffInviteIndexRoute
  '/customers/automations/$id/logs/': typeof CustomersAutomationsIdLogsIndexRoute
  '/customers/groups/$id/edit/': typeof CustomersGroupsIdEditIndexRoute
  '/inventory/purchase-orders/vendors/$id/': typeof InventoryPurchaseOrdersVendorsIdIndexRoute
  '/inventory/purchase-orders/vendors/new/': typeof InventoryPurchaseOrdersVendorsNewIndexRoute
  '/marketing/automations/$id/logs/': typeof MarketingAutomationsIdLogsIndexRoute
  '/orders/automations/$id/logs/': typeof OrdersAutomationsIdLogsIndexRoute
  '/products/automations/$id/logs/': typeof ProductsAutomationsIdLogsIndexRoute
  '/settings/messaging/whatsapp/templates/': typeof SettingsMessagingWhatsappTemplatesIndexRoute
  '/settings/shipping/kayn-ship/wallet/': typeof SettingsShippingKaynShipWalletIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteIndexRoute
  '/attributes': typeof AttributesIndexRoute
  '/blog': typeof BlogIndexRoute
  '/brands': typeof BrandsIndexRoute
  '/capabilities': typeof CapabilitiesIndexRoute
  '/categories': typeof CategoriesIndexRoute
  '/collections': typeof CollectionsIndexRoute
  '/customers': typeof CustomersIndexRoute
  '/facets': typeof FacetsIndexRoute
  '/filters': typeof FiltersIndexRoute
  '/finance': typeof FinanceIndexRoute
  '/gift-cards': typeof GiftCardsIndexRoute
  '/inventory': typeof InventoryIndexRoute
  '/login': typeof LoginIndexRoute
  '/marketing': typeof MarketingIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/pages': typeof PagesIndexRoute
  '/product-properties': typeof ProductPropertiesIndexRoute
  '/product-templates': typeof ProductTemplatesIndexRoute
  '/products': typeof ProductsIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/sales-channels': typeof SalesChannelsIndexRoute
  '/select-store': typeof SelectStoreIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/signup': typeof SignupIndexRoute
  '/stock-locations': typeof StockLocationsIndexRoute
  '/verify-2fa': typeof Verify2faIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/attributes/$id': typeof AttributesIdIndexRoute
  '/blog/$id': typeof BlogIdIndexRoute
  '/blog/categories': typeof BlogCategoriesIndexRoute
  '/blog/new': typeof BlogNewIndexRoute
  '/brands/$id': typeof BrandsIdIndexRoute
  '/brands/new': typeof BrandsNewIndexRoute
  '/catalog/labels': typeof CatalogLabelsIndexRoute
  '/categories/$id': typeof CategoriesIdIndexRoute
  '/categories/new': typeof CategoriesNewIndexRoute
  '/collections/$id': typeof CollectionsIdIndexRoute
  '/collections/new': typeof CollectionsNewIndexRoute
  '/customers/$id': typeof CustomersIdIndexRoute
  '/customers/automations': typeof CustomersAutomationsIndexRoute
  '/customers/groups': typeof CustomersGroupsIndexRoute
  '/customers/new': typeof CustomersNewIndexRoute
  '/customers/questions': typeof CustomersQuestionsIndexRoute
  '/customers/review-requests': typeof CustomersReviewRequestsIndexRoute
  '/customers/reviews': typeof CustomersReviewsIndexRoute
  '/customers/rfm': typeof CustomersRfmIndexRoute
  '/customers/smart-segments': typeof CustomersSmartSegmentsIndexRoute
  '/facets/$id': typeof FacetsIdIndexRoute
  '/facets/new': typeof FacetsNewIndexRoute
  '/filters/$id': typeof FiltersIdIndexRoute
  '/filters/new': typeof FiltersNewIndexRoute
  '/finance/transactions': typeof FinanceTransactionsIndexRoute
  '/gift-cards/$id': typeof GiftCardsIdIndexRoute
  '/gift-cards/settings': typeof GiftCardsSettingsIndexRoute
  '/inventory/history': typeof InventoryHistoryIndexRoute
  '/inventory/purchase-orders': typeof InventoryPurchaseOrdersIndexRoute
  '/inventory/transfers': typeof InventoryTransfersIndexRoute
  '/marketing/abandoned-carts': typeof MarketingAbandonedCartsIndexRoute
  '/marketing/affiliates': typeof MarketingAffiliatesIndexRoute
  '/marketing/announcements': typeof MarketingAnnouncementsIndexRoute
  '/marketing/automations': typeof MarketingAutomationsIndexRoute
  '/marketing/back-in-stock': typeof MarketingBackInStockIndexRoute
  '/marketing/calendar': typeof MarketingCalendarIndexRoute
  '/marketing/cashback': typeof MarketingCashbackIndexRoute
  '/marketing/catalog-discounts': typeof MarketingCatalogDiscountsIndexRoute
  '/marketing/discounts': typeof MarketingDiscountsIndexRoute
  '/marketing/loyalty': typeof MarketingLoyaltyIndexRoute
  '/marketing/product-feeds': typeof MarketingProductFeedsIndexRoute
  '/marketing/push-notifications': typeof MarketingPushNotificationsIndexRoute
  '/marketing/referrals': typeof MarketingReferralsIndexRoute
  '/marketing/repurchase-reminders': typeof MarketingRepurchaseRemindersIndexRoute
  '/marketing/sales-boosters': typeof MarketingSalesBoostersIndexRoute
  '/marketing/segments': typeof MarketingSegmentsIndexRoute
  '/marketing/seo': typeof MarketingSeoIndexRoute
  '/orders/$id': typeof OrdersIdIndexRoute
  '/orders/automations': typeof OrdersAutomationsIndexRoute
  '/orders/drafts': typeof OrdersDraftsIndexRoute
  '/orders/fulfilment': typeof OrdersFulfilmentIndexRoute
  '/orders/invoices': typeof OrdersInvoicesIndexRoute
  '/orders/new': typeof OrdersNewIndexRoute
  '/orders/returns': typeof OrdersReturnsIndexRoute
  '/orders/shipments': typeof OrdersShipmentsIndexRoute
  '/pages/$id': typeof PagesIdIndexRoute
  '/pages/new': typeof PagesNewIndexRoute
  '/products/$id': typeof ProductsIdIndexRoute
  '/products/automations': typeof ProductsAutomationsIndexRoute
  '/products/bulk-edit': typeof ProductsBulkEditIndexRoute
  '/products/new': typeof ProductsNewIndexRoute
  '/reports/customers': typeof ReportsCustomersIndexRoute
  '/reports/financial': typeof ReportsFinancialIndexRoute
  '/reports/loyalty': typeof ReportsLoyaltyIndexRoute
  '/reports/orders': typeof ReportsOrdersIndexRoute
  '/reports/products': typeof ReportsProductsIndexRoute
  '/reports/sales': typeof ReportsSalesIndexRoute
  '/sales-channels/mobile-app': typeof SalesChannelsMobileAppIndexRoute
  '/sales-channels/online-store': typeof SalesChannelsOnlineStoreIndexRoute
  '/sales-channels/pos': typeof SalesChannelsPosIndexRoute
  '/settings/apps': typeof SettingsAppsIndexRoute
  '/settings/billing': typeof SettingsBillingIndexRoute
  '/settings/checkout-restrictions': typeof SettingsCheckoutRestrictionsIndexRoute
  '/settings/checkout-risk': typeof SettingsCheckoutRiskIndexRoute
  '/settings/checkout': typeof SettingsCheckoutIndexRoute
  '/settings/content-blocks': typeof SettingsContentBlocksIndexRoute
  '/settings/data-migration': typeof SettingsDataMigrationIndexRoute
  '/settings/domains': typeof SettingsDomainsIndexRoute
  '/settings/gift-options': typeof SettingsGiftOptionsIndexRoute
  '/settings/integrations': typeof SettingsIntegrationsIndexRoute
  '/settings/inventory': typeof SettingsInventoryIndexRoute
  '/settings/invoices': typeof SettingsInvoicesIndexRoute
  '/settings/languages': typeof SettingsLanguagesIndexRoute
  '/settings/localization': typeof SettingsLocalizationIndexRoute
  '/settings/markets': typeof SettingsMarketsIndexRoute
  '/settings/messaging': typeof SettingsMessagingIndexRoute
  '/settings/metafield-definitions': typeof SettingsMetafieldDefinitionsIndexRoute
  '/settings/notifications': typeof SettingsNotificationsIndexRoute
  '/settings/operations': typeof SettingsOperationsIndexRoute
  '/settings/order-customizations': typeof SettingsOrderCustomizationsIndexRoute
  '/settings/payment-methods': typeof SettingsPaymentMethodsIndexRoute
  '/settings/profile': typeof SettingsProfileIndexRoute
  '/settings/return-policy': typeof SettingsReturnPolicyIndexRoute
  '/settings/scheduling': typeof SettingsSchedulingIndexRoute
  '/settings/security': typeof SettingsSecurityIndexRoute
  '/settings/shipping': typeof SettingsShippingIndexRoute
  '/settings/staff': typeof SettingsStaffIndexRoute
  '/settings/store': typeof SettingsStoreIndexRoute
  '/settings/tax': typeof SettingsTaxIndexRoute
  '/settings/testimonials': typeof SettingsTestimonialsIndexRoute
  '/stock-locations/$id': typeof StockLocationsIdIndexRoute
  '/stock-locations/new': typeof StockLocationsNewIndexRoute
  '/catalog/labels/$id': typeof CatalogLabelsIdIndexRoute
  '/catalog/labels/new': typeof CatalogLabelsNewIndexRoute
  '/catalog/labels/settings': typeof CatalogLabelsSettingsIndexRoute
  '/customers/$id/edit': typeof CustomersIdEditIndexRoute
  '/customers/automations/$id': typeof CustomersAutomationsIdIndexRoute
  '/customers/automations/new': typeof CustomersAutomationsNewIndexRoute
  '/customers/groups/$id': typeof CustomersGroupsIdIndexRoute
  '/customers/groups/new': typeof CustomersGroupsNewIndexRoute
  '/customers/reviews/$id': typeof CustomersReviewsIdIndexRoute
  '/inventory/purchase-orders/$id': typeof InventoryPurchaseOrdersIdIndexRoute
  '/inventory/purchase-orders/new': typeof InventoryPurchaseOrdersNewIndexRoute
  '/inventory/purchase-orders/vendors': typeof InventoryPurchaseOrdersVendorsIndexRoute
  '/inventory/transfers/$id': typeof InventoryTransfersIdIndexRoute
  '/inventory/transfers/new': typeof InventoryTransfersNewIndexRoute
  '/marketing/affiliates/$id': typeof MarketingAffiliatesIdIndexRoute
  '/marketing/affiliates/new': typeof MarketingAffiliatesNewIndexRoute
  '/marketing/affiliates/settings': typeof MarketingAffiliatesSettingsIndexRoute
  '/marketing/automations/$id': typeof MarketingAutomationsIdIndexRoute
  '/marketing/automations/new': typeof MarketingAutomationsNewIndexRoute
  '/marketing/automations/secrets': typeof MarketingAutomationsSecretsIndexRoute
  '/marketing/cashback/$id': typeof MarketingCashbackIdIndexRoute
  '/marketing/cashback/new': typeof MarketingCashbackNewIndexRoute
  '/marketing/catalog-discounts/$id': typeof MarketingCatalogDiscountsIdIndexRoute
  '/marketing/catalog-discounts/new': typeof MarketingCatalogDiscountsNewIndexRoute
  '/marketing/discounts/$id': typeof MarketingDiscountsIdIndexRoute
  '/marketing/discounts/new': typeof MarketingDiscountsNewIndexRoute
  '/marketing/referrals/settings': typeof MarketingReferralsSettingsIndexRoute
  '/orders/$id/modify': typeof OrdersIdModifyIndexRoute
  '/orders/automations/$id': typeof OrdersAutomationsIdIndexRoute
  '/orders/automations/new': typeof OrdersAutomationsNewIndexRoute
  '/orders/draft/$id': typeof OrdersDraftIdIndexRoute
  '/orders/returns/$id': typeof OrdersReturnsIdIndexRoute
  '/products/automations/$id': typeof ProductsAutomationsIdIndexRoute
  '/products/automations/new': typeof ProductsAutomationsNewIndexRoute
  '/sales-channels/mobile-app/design': typeof SalesChannelsMobileAppDesignIndexRoute
  '/sales-channels/mobile-app/homepage': typeof SalesChannelsMobileAppHomepageIndexRoute
  '/sales-channels/mobile-app/identity': typeof SalesChannelsMobileAppIdentityIndexRoute
  '/sales-channels/mobile-app/notifications': typeof SalesChannelsMobileAppNotificationsIndexRoute
  '/sales-channels/mobile-app/settings': typeof SalesChannelsMobileAppSettingsIndexRoute
  '/sales-channels/online-store/design': typeof SalesChannelsOnlineStoreDesignIndexRoute
  '/sales-channels/online-store/product-experience': typeof SalesChannelsOnlineStoreProductExperienceIndexRoute
  '/settings/apps/$appCode': typeof SettingsAppsAppCodeIndexRoute
  '/settings/billing/add-ons': typeof SettingsBillingAddOnsIndexRoute
  '/settings/billing/invoices': typeof SettingsBillingInvoicesIndexRoute
  '/settings/billing/payment-methods': typeof SettingsBillingPaymentMethodsIndexRoute
  '/settings/messaging/logs': typeof SettingsMessagingLogsIndexRoute
  '/settings/messaging/whatsapp': typeof SettingsMessagingWhatsappIndexRoute
  '/settings/metafield-definitions/$id': typeof SettingsMetafieldDefinitionsIdIndexRoute
  '/settings/metafield-definitions/new': typeof SettingsMetafieldDefinitionsNewIndexRoute
  '/settings/payment-methods/activate': typeof SettingsPaymentMethodsActivateIndexRoute
  '/settings/payment-methods/bank-transfer': typeof SettingsPaymentMethodsBankTransferIndexRoute
  '/settings/scheduling/$id': typeof SettingsSchedulingIdIndexRoute
  '/settings/shipping/$carrierCode': typeof SettingsShippingCarrierCodeIndexRoute
  '/settings/shipping/kayn-ship': typeof SettingsShippingKaynShipIndexRoute
  '/settings/shipping/manual': typeof SettingsShippingManualIndexRoute
  '/settings/staff/$id': typeof SettingsStaffIdIndexRoute
  '/settings/staff/invite': typeof SettingsStaffInviteIndexRoute
  '/customers/automations/$id/logs': typeof CustomersAutomationsIdLogsIndexRoute
  '/customers/groups/$id/edit': typeof CustomersGroupsIdEditIndexRoute
  '/inventory/purchase-orders/vendors/$id': typeof InventoryPurchaseOrdersVendorsIdIndexRoute
  '/inventory/purchase-orders/vendors/new': typeof InventoryPurchaseOrdersVendorsNewIndexRoute
  '/marketing/automations/$id/logs': typeof MarketingAutomationsIdLogsIndexRoute
  '/orders/automations/$id/logs': typeof OrdersAutomationsIdLogsIndexRoute
  '/products/automations/$id/logs': typeof ProductsAutomationsIdLogsIndexRoute
  '/settings/messaging/whatsapp/templates': typeof SettingsMessagingWhatsappTemplatesIndexRoute
  '/settings/shipping/kayn-ship/wallet': typeof SettingsShippingKaynShipWalletIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/finance': typeof FinanceRouteRouteWithChildren
  '/reports': typeof ReportsRouteRouteWithChildren
  '/sales-channels/mobile-app': typeof SalesChannelsMobileAppRouteRouteWithChildren
  '/accept-invite/': typeof AcceptInviteIndexRoute
  '/attributes/': typeof AttributesIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/capabilities/': typeof CapabilitiesIndexRoute
  '/categories/': typeof CategoriesIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/facets/': typeof FacetsIndexRoute
  '/filters/': typeof FiltersIndexRoute
  '/finance/': typeof FinanceIndexRoute
  '/gift-cards/': typeof GiftCardsIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/login/': typeof LoginIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/pages/': typeof PagesIndexRoute
  '/product-properties/': typeof ProductPropertiesIndexRoute
  '/product-templates/': typeof ProductTemplatesIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/sales-channels/': typeof SalesChannelsIndexRoute
  '/select-store/': typeof SelectStoreIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/stock-locations/': typeof StockLocationsIndexRoute
  '/verify-2fa/': typeof Verify2faIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/attributes/$id/': typeof AttributesIdIndexRoute
  '/blog/$id/': typeof BlogIdIndexRoute
  '/blog/categories/': typeof BlogCategoriesIndexRoute
  '/blog/new/': typeof BlogNewIndexRoute
  '/brands/$id/': typeof BrandsIdIndexRoute
  '/brands/new/': typeof BrandsNewIndexRoute
  '/catalog/labels/': typeof CatalogLabelsIndexRoute
  '/categories/$id/': typeof CategoriesIdIndexRoute
  '/categories/new/': typeof CategoriesNewIndexRoute
  '/collections/$id/': typeof CollectionsIdIndexRoute
  '/collections/new/': typeof CollectionsNewIndexRoute
  '/customers/$id/': typeof CustomersIdIndexRoute
  '/customers/automations/': typeof CustomersAutomationsIndexRoute
  '/customers/groups/': typeof CustomersGroupsIndexRoute
  '/customers/new/': typeof CustomersNewIndexRoute
  '/customers/questions/': typeof CustomersQuestionsIndexRoute
  '/customers/review-requests/': typeof CustomersReviewRequestsIndexRoute
  '/customers/reviews/': typeof CustomersReviewsIndexRoute
  '/customers/rfm/': typeof CustomersRfmIndexRoute
  '/customers/smart-segments/': typeof CustomersSmartSegmentsIndexRoute
  '/facets/$id/': typeof FacetsIdIndexRoute
  '/facets/new/': typeof FacetsNewIndexRoute
  '/filters/$id/': typeof FiltersIdIndexRoute
  '/filters/new/': typeof FiltersNewIndexRoute
  '/finance/transactions/': typeof FinanceTransactionsIndexRoute
  '/gift-cards/$id/': typeof GiftCardsIdIndexRoute
  '/gift-cards/settings/': typeof GiftCardsSettingsIndexRoute
  '/inventory/history/': typeof InventoryHistoryIndexRoute
  '/inventory/purchase-orders/': typeof InventoryPurchaseOrdersIndexRoute
  '/inventory/transfers/': typeof InventoryTransfersIndexRoute
  '/marketing/abandoned-carts/': typeof MarketingAbandonedCartsIndexRoute
  '/marketing/affiliates/': typeof MarketingAffiliatesIndexRoute
  '/marketing/announcements/': typeof MarketingAnnouncementsIndexRoute
  '/marketing/automations/': typeof MarketingAutomationsIndexRoute
  '/marketing/back-in-stock/': typeof MarketingBackInStockIndexRoute
  '/marketing/calendar/': typeof MarketingCalendarIndexRoute
  '/marketing/cashback/': typeof MarketingCashbackIndexRoute
  '/marketing/catalog-discounts/': typeof MarketingCatalogDiscountsIndexRoute
  '/marketing/discounts/': typeof MarketingDiscountsIndexRoute
  '/marketing/loyalty/': typeof MarketingLoyaltyIndexRoute
  '/marketing/product-feeds/': typeof MarketingProductFeedsIndexRoute
  '/marketing/push-notifications/': typeof MarketingPushNotificationsIndexRoute
  '/marketing/referrals/': typeof MarketingReferralsIndexRoute
  '/marketing/repurchase-reminders/': typeof MarketingRepurchaseRemindersIndexRoute
  '/marketing/sales-boosters/': typeof MarketingSalesBoostersIndexRoute
  '/marketing/segments/': typeof MarketingSegmentsIndexRoute
  '/marketing/seo/': typeof MarketingSeoIndexRoute
  '/orders/$id/': typeof OrdersIdIndexRoute
  '/orders/automations/': typeof OrdersAutomationsIndexRoute
  '/orders/drafts/': typeof OrdersDraftsIndexRoute
  '/orders/fulfilment/': typeof OrdersFulfilmentIndexRoute
  '/orders/invoices/': typeof OrdersInvoicesIndexRoute
  '/orders/new/': typeof OrdersNewIndexRoute
  '/orders/returns/': typeof OrdersReturnsIndexRoute
  '/orders/shipments/': typeof OrdersShipmentsIndexRoute
  '/pages/$id/': typeof PagesIdIndexRoute
  '/pages/new/': typeof PagesNewIndexRoute
  '/products/$id/': typeof ProductsIdIndexRoute
  '/products/automations/': typeof ProductsAutomationsIndexRoute
  '/products/bulk-edit/': typeof ProductsBulkEditIndexRoute
  '/products/new/': typeof ProductsNewIndexRoute
  '/reports/customers/': typeof ReportsCustomersIndexRoute
  '/reports/financial/': typeof ReportsFinancialIndexRoute
  '/reports/loyalty/': typeof ReportsLoyaltyIndexRoute
  '/reports/orders/': typeof ReportsOrdersIndexRoute
  '/reports/products/': typeof ReportsProductsIndexRoute
  '/reports/sales/': typeof ReportsSalesIndexRoute
  '/sales-channels/mobile-app/': typeof SalesChannelsMobileAppIndexRoute
  '/sales-channels/online-store/': typeof SalesChannelsOnlineStoreIndexRoute
  '/sales-channels/pos/': typeof SalesChannelsPosIndexRoute
  '/settings/apps/': typeof SettingsAppsIndexRoute
  '/settings/billing/': typeof SettingsBillingIndexRoute
  '/settings/checkout-restrictions/': typeof SettingsCheckoutRestrictionsIndexRoute
  '/settings/checkout-risk/': typeof SettingsCheckoutRiskIndexRoute
  '/settings/checkout/': typeof SettingsCheckoutIndexRoute
  '/settings/content-blocks/': typeof SettingsContentBlocksIndexRoute
  '/settings/data-migration/': typeof SettingsDataMigrationIndexRoute
  '/settings/domains/': typeof SettingsDomainsIndexRoute
  '/settings/gift-options/': typeof SettingsGiftOptionsIndexRoute
  '/settings/integrations/': typeof SettingsIntegrationsIndexRoute
  '/settings/inventory/': typeof SettingsInventoryIndexRoute
  '/settings/invoices/': typeof SettingsInvoicesIndexRoute
  '/settings/languages/': typeof SettingsLanguagesIndexRoute
  '/settings/localization/': typeof SettingsLocalizationIndexRoute
  '/settings/markets/': typeof SettingsMarketsIndexRoute
  '/settings/messaging/': typeof SettingsMessagingIndexRoute
  '/settings/metafield-definitions/': typeof SettingsMetafieldDefinitionsIndexRoute
  '/settings/notifications/': typeof SettingsNotificationsIndexRoute
  '/settings/operations/': typeof SettingsOperationsIndexRoute
  '/settings/order-customizations/': typeof SettingsOrderCustomizationsIndexRoute
  '/settings/payment-methods/': typeof SettingsPaymentMethodsIndexRoute
  '/settings/profile/': typeof SettingsProfileIndexRoute
  '/settings/return-policy/': typeof SettingsReturnPolicyIndexRoute
  '/settings/scheduling/': typeof SettingsSchedulingIndexRoute
  '/settings/security/': typeof SettingsSecurityIndexRoute
  '/settings/shipping/': typeof SettingsShippingIndexRoute
  '/settings/staff/': typeof SettingsStaffIndexRoute
  '/settings/store/': typeof SettingsStoreIndexRoute
  '/settings/tax/': typeof SettingsTaxIndexRoute
  '/settings/testimonials/': typeof SettingsTestimonialsIndexRoute
  '/stock-locations/$id/': typeof StockLocationsIdIndexRoute
  '/stock-locations/new/': typeof StockLocationsNewIndexRoute
  '/catalog/labels/$id/': typeof CatalogLabelsIdIndexRoute
  '/catalog/labels/new/': typeof CatalogLabelsNewIndexRoute
  '/catalog/labels/settings/': typeof CatalogLabelsSettingsIndexRoute
  '/customers/$id/edit/': typeof CustomersIdEditIndexRoute
  '/customers/automations/$id/': typeof CustomersAutomationsIdIndexRoute
  '/customers/automations/new/': typeof CustomersAutomationsNewIndexRoute
  '/customers/groups/$id/': typeof CustomersGroupsIdIndexRoute
  '/customers/groups/new/': typeof CustomersGroupsNewIndexRoute
  '/customers/reviews/$id/': typeof CustomersReviewsIdIndexRoute
  '/inventory/purchase-orders/$id/': typeof InventoryPurchaseOrdersIdIndexRoute
  '/inventory/purchase-orders/new/': typeof InventoryPurchaseOrdersNewIndexRoute
  '/inventory/purchase-orders/vendors/': typeof InventoryPurchaseOrdersVendorsIndexRoute
  '/inventory/transfers/$id/': typeof InventoryTransfersIdIndexRoute
  '/inventory/transfers/new/': typeof InventoryTransfersNewIndexRoute
  '/marketing/affiliates/$id/': typeof MarketingAffiliatesIdIndexRoute
  '/marketing/affiliates/new/': typeof MarketingAffiliatesNewIndexRoute
  '/marketing/affiliates/settings/': typeof MarketingAffiliatesSettingsIndexRoute
  '/marketing/automations/$id/': typeof MarketingAutomationsIdIndexRoute
  '/marketing/automations/new/': typeof MarketingAutomationsNewIndexRoute
  '/marketing/automations/secrets/': typeof MarketingAutomationsSecretsIndexRoute
  '/marketing/cashback/$id/': typeof MarketingCashbackIdIndexRoute
  '/marketing/cashback/new/': typeof MarketingCashbackNewIndexRoute
  '/marketing/catalog-discounts/$id/': typeof MarketingCatalogDiscountsIdIndexRoute
  '/marketing/catalog-discounts/new/': typeof MarketingCatalogDiscountsNewIndexRoute
  '/marketing/discounts/$id/': typeof MarketingDiscountsIdIndexRoute
  '/marketing/discounts/new/': typeof MarketingDiscountsNewIndexRoute
  '/marketing/referrals/settings/': typeof MarketingReferralsSettingsIndexRoute
  '/orders/$id/modify/': typeof OrdersIdModifyIndexRoute
  '/orders/automations/$id/': typeof OrdersAutomationsIdIndexRoute
  '/orders/automations/new/': typeof OrdersAutomationsNewIndexRoute
  '/orders/draft/$id/': typeof OrdersDraftIdIndexRoute
  '/orders/returns/$id/': typeof OrdersReturnsIdIndexRoute
  '/products/automations/$id/': typeof ProductsAutomationsIdIndexRoute
  '/products/automations/new/': typeof ProductsAutomationsNewIndexRoute
  '/sales-channels/mobile-app/design/': typeof SalesChannelsMobileAppDesignIndexRoute
  '/sales-channels/mobile-app/homepage/': typeof SalesChannelsMobileAppHomepageIndexRoute
  '/sales-channels/mobile-app/identity/': typeof SalesChannelsMobileAppIdentityIndexRoute
  '/sales-channels/mobile-app/notifications/': typeof SalesChannelsMobileAppNotificationsIndexRoute
  '/sales-channels/mobile-app/settings/': typeof SalesChannelsMobileAppSettingsIndexRoute
  '/sales-channels/online-store/design/': typeof SalesChannelsOnlineStoreDesignIndexRoute
  '/sales-channels/online-store/product-experience/': typeof SalesChannelsOnlineStoreProductExperienceIndexRoute
  '/settings/apps/$appCode/': typeof SettingsAppsAppCodeIndexRoute
  '/settings/billing/add-ons/': typeof SettingsBillingAddOnsIndexRoute
  '/settings/billing/invoices/': typeof SettingsBillingInvoicesIndexRoute
  '/settings/billing/payment-methods/': typeof SettingsBillingPaymentMethodsIndexRoute
  '/settings/messaging/logs/': typeof SettingsMessagingLogsIndexRoute
  '/settings/messaging/whatsapp/': typeof SettingsMessagingWhatsappIndexRoute
  '/settings/metafield-definitions/$id/': typeof SettingsMetafieldDefinitionsIdIndexRoute
  '/settings/metafield-definitions/new/': typeof SettingsMetafieldDefinitionsNewIndexRoute
  '/settings/payment-methods/activate/': typeof SettingsPaymentMethodsActivateIndexRoute
  '/settings/payment-methods/bank-transfer/': typeof SettingsPaymentMethodsBankTransferIndexRoute
  '/settings/scheduling/$id/': typeof SettingsSchedulingIdIndexRoute
  '/settings/shipping/$carrierCode/': typeof SettingsShippingCarrierCodeIndexRoute
  '/settings/shipping/kayn-ship/': typeof SettingsShippingKaynShipIndexRoute
  '/settings/shipping/manual/': typeof SettingsShippingManualIndexRoute
  '/settings/staff/$id/': typeof SettingsStaffIdIndexRoute
  '/settings/staff/invite/': typeof SettingsStaffInviteIndexRoute
  '/customers/automations/$id/logs/': typeof CustomersAutomationsIdLogsIndexRoute
  '/customers/groups/$id/edit/': typeof CustomersGroupsIdEditIndexRoute
  '/inventory/purchase-orders/vendors/$id/': typeof InventoryPurchaseOrdersVendorsIdIndexRoute
  '/inventory/purchase-orders/vendors/new/': typeof InventoryPurchaseOrdersVendorsNewIndexRoute
  '/marketing/automations/$id/logs/': typeof MarketingAutomationsIdLogsIndexRoute
  '/orders/automations/$id/logs/': typeof OrdersAutomationsIdLogsIndexRoute
  '/products/automations/$id/logs/': typeof ProductsAutomationsIdLogsIndexRoute
  '/settings/messaging/whatsapp/templates/': typeof SettingsMessagingWhatsappTemplatesIndexRoute
  '/settings/shipping/kayn-ship/wallet/': typeof SettingsShippingKaynShipWalletIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/finance'
    | '/reports'
    | '/sales-channels/mobile-app'
    | '/accept-invite/'
    | '/attributes/'
    | '/blog/'
    | '/brands/'
    | '/capabilities/'
    | '/categories/'
    | '/collections/'
    | '/customers/'
    | '/facets/'
    | '/filters/'
    | '/finance/'
    | '/gift-cards/'
    | '/inventory/'
    | '/login/'
    | '/marketing/'
    | '/notifications/'
    | '/onboarding/'
    | '/orders/'
    | '/pages/'
    | '/product-properties/'
    | '/product-templates/'
    | '/products/'
    | '/reports/'
    | '/reset-password/'
    | '/sales-channels/'
    | '/select-store/'
    | '/settings/'
    | '/signup/'
    | '/stock-locations/'
    | '/verify-2fa/'
    | '/verify-email/'
    | '/attributes/$id/'
    | '/blog/$id/'
    | '/blog/categories/'
    | '/blog/new/'
    | '/brands/$id/'
    | '/brands/new/'
    | '/catalog/labels/'
    | '/categories/$id/'
    | '/categories/new/'
    | '/collections/$id/'
    | '/collections/new/'
    | '/customers/$id/'
    | '/customers/automations/'
    | '/customers/groups/'
    | '/customers/new/'
    | '/customers/questions/'
    | '/customers/review-requests/'
    | '/customers/reviews/'
    | '/customers/rfm/'
    | '/customers/smart-segments/'
    | '/facets/$id/'
    | '/facets/new/'
    | '/filters/$id/'
    | '/filters/new/'
    | '/finance/transactions/'
    | '/gift-cards/$id/'
    | '/gift-cards/settings/'
    | '/inventory/history/'
    | '/inventory/purchase-orders/'
    | '/inventory/transfers/'
    | '/marketing/abandoned-carts/'
    | '/marketing/affiliates/'
    | '/marketing/announcements/'
    | '/marketing/automations/'
    | '/marketing/back-in-stock/'
    | '/marketing/calendar/'
    | '/marketing/cashback/'
    | '/marketing/catalog-discounts/'
    | '/marketing/discounts/'
    | '/marketing/loyalty/'
    | '/marketing/product-feeds/'
    | '/marketing/push-notifications/'
    | '/marketing/referrals/'
    | '/marketing/repurchase-reminders/'
    | '/marketing/sales-boosters/'
    | '/marketing/segments/'
    | '/marketing/seo/'
    | '/orders/$id/'
    | '/orders/automations/'
    | '/orders/drafts/'
    | '/orders/fulfilment/'
    | '/orders/invoices/'
    | '/orders/new/'
    | '/orders/returns/'
    | '/orders/shipments/'
    | '/pages/$id/'
    | '/pages/new/'
    | '/products/$id/'
    | '/products/automations/'
    | '/products/bulk-edit/'
    | '/products/new/'
    | '/reports/customers/'
    | '/reports/financial/'
    | '/reports/loyalty/'
    | '/reports/orders/'
    | '/reports/products/'
    | '/reports/sales/'
    | '/sales-channels/mobile-app/'
    | '/sales-channels/online-store/'
    | '/sales-channels/pos/'
    | '/settings/apps/'
    | '/settings/billing/'
    | '/settings/checkout-restrictions/'
    | '/settings/checkout-risk/'
    | '/settings/checkout/'
    | '/settings/content-blocks/'
    | '/settings/data-migration/'
    | '/settings/domains/'
    | '/settings/gift-options/'
    | '/settings/integrations/'
    | '/settings/inventory/'
    | '/settings/invoices/'
    | '/settings/languages/'
    | '/settings/localization/'
    | '/settings/markets/'
    | '/settings/messaging/'
    | '/settings/metafield-definitions/'
    | '/settings/notifications/'
    | '/settings/operations/'
    | '/settings/order-customizations/'
    | '/settings/payment-methods/'
    | '/settings/profile/'
    | '/settings/return-policy/'
    | '/settings/scheduling/'
    | '/settings/security/'
    | '/settings/shipping/'
    | '/settings/staff/'
    | '/settings/store/'
    | '/settings/tax/'
    | '/settings/testimonials/'
    | '/stock-locations/$id/'
    | '/stock-locations/new/'
    | '/catalog/labels/$id/'
    | '/catalog/labels/new/'
    | '/catalog/labels/settings/'
    | '/customers/$id/edit/'
    | '/customers/automations/$id/'
    | '/customers/automations/new/'
    | '/customers/groups/$id/'
    | '/customers/groups/new/'
    | '/customers/reviews/$id/'
    | '/inventory/purchase-orders/$id/'
    | '/inventory/purchase-orders/new/'
    | '/inventory/purchase-orders/vendors/'
    | '/inventory/transfers/$id/'
    | '/inventory/transfers/new/'
    | '/marketing/affiliates/$id/'
    | '/marketing/affiliates/new/'
    | '/marketing/affiliates/settings/'
    | '/marketing/automations/$id/'
    | '/marketing/automations/new/'
    | '/marketing/automations/secrets/'
    | '/marketing/cashback/$id/'
    | '/marketing/cashback/new/'
    | '/marketing/catalog-discounts/$id/'
    | '/marketing/catalog-discounts/new/'
    | '/marketing/discounts/$id/'
    | '/marketing/discounts/new/'
    | '/marketing/referrals/settings/'
    | '/orders/$id/modify/'
    | '/orders/automations/$id/'
    | '/orders/automations/new/'
    | '/orders/draft/$id/'
    | '/orders/returns/$id/'
    | '/products/automations/$id/'
    | '/products/automations/new/'
    | '/sales-channels/mobile-app/design/'
    | '/sales-channels/mobile-app/homepage/'
    | '/sales-channels/mobile-app/identity/'
    | '/sales-channels/mobile-app/notifications/'
    | '/sales-channels/mobile-app/settings/'
    | '/sales-channels/online-store/design/'
    | '/sales-channels/online-store/product-experience/'
    | '/settings/apps/$appCode/'
    | '/settings/billing/add-ons/'
    | '/settings/billing/invoices/'
    | '/settings/billing/payment-methods/'
    | '/settings/messaging/logs/'
    | '/settings/messaging/whatsapp/'
    | '/settings/metafield-definitions/$id/'
    | '/settings/metafield-definitions/new/'
    | '/settings/payment-methods/activate/'
    | '/settings/payment-methods/bank-transfer/'
    | '/settings/scheduling/$id/'
    | '/settings/shipping/$carrierCode/'
    | '/settings/shipping/kayn-ship/'
    | '/settings/shipping/manual/'
    | '/settings/staff/$id/'
    | '/settings/staff/invite/'
    | '/customers/automations/$id/logs/'
    | '/customers/groups/$id/edit/'
    | '/inventory/purchase-orders/vendors/$id/'
    | '/inventory/purchase-orders/vendors/new/'
    | '/marketing/automations/$id/logs/'
    | '/orders/automations/$id/logs/'
    | '/products/automations/$id/logs/'
    | '/settings/messaging/whatsapp/templates/'
    | '/settings/shipping/kayn-ship/wallet/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/attributes'
    | '/blog'
    | '/brands'
    | '/capabilities'
    | '/categories'
    | '/collections'
    | '/customers'
    | '/facets'
    | '/filters'
    | '/finance'
    | '/gift-cards'
    | '/inventory'
    | '/login'
    | '/marketing'
    | '/notifications'
    | '/onboarding'
    | '/orders'
    | '/pages'
    | '/product-properties'
    | '/product-templates'
    | '/products'
    | '/reports'
    | '/reset-password'
    | '/sales-channels'
    | '/select-store'
    | '/settings'
    | '/signup'
    | '/stock-locations'
    | '/verify-2fa'
    | '/verify-email'
    | '/attributes/$id'
    | '/blog/$id'
    | '/blog/categories'
    | '/blog/new'
    | '/brands/$id'
    | '/brands/new'
    | '/catalog/labels'
    | '/categories/$id'
    | '/categories/new'
    | '/collections/$id'
    | '/collections/new'
    | '/customers/$id'
    | '/customers/automations'
    | '/customers/groups'
    | '/customers/new'
    | '/customers/questions'
    | '/customers/review-requests'
    | '/customers/reviews'
    | '/customers/rfm'
    | '/customers/smart-segments'
    | '/facets/$id'
    | '/facets/new'
    | '/filters/$id'
    | '/filters/new'
    | '/finance/transactions'
    | '/gift-cards/$id'
    | '/gift-cards/settings'
    | '/inventory/history'
    | '/inventory/purchase-orders'
    | '/inventory/transfers'
    | '/marketing/abandoned-carts'
    | '/marketing/affiliates'
    | '/marketing/announcements'
    | '/marketing/automations'
    | '/marketing/back-in-stock'
    | '/marketing/calendar'
    | '/marketing/cashback'
    | '/marketing/catalog-discounts'
    | '/marketing/discounts'
    | '/marketing/loyalty'
    | '/marketing/product-feeds'
    | '/marketing/push-notifications'
    | '/marketing/referrals'
    | '/marketing/repurchase-reminders'
    | '/marketing/sales-boosters'
    | '/marketing/segments'
    | '/marketing/seo'
    | '/orders/$id'
    | '/orders/automations'
    | '/orders/drafts'
    | '/orders/fulfilment'
    | '/orders/invoices'
    | '/orders/new'
    | '/orders/returns'
    | '/orders/shipments'
    | '/pages/$id'
    | '/pages/new'
    | '/products/$id'
    | '/products/automations'
    | '/products/bulk-edit'
    | '/products/new'
    | '/reports/customers'
    | '/reports/financial'
    | '/reports/loyalty'
    | '/reports/orders'
    | '/reports/products'
    | '/reports/sales'
    | '/sales-channels/mobile-app'
    | '/sales-channels/online-store'
    | '/sales-channels/pos'
    | '/settings/apps'
    | '/settings/billing'
    | '/settings/checkout-restrictions'
    | '/settings/checkout-risk'
    | '/settings/checkout'
    | '/settings/content-blocks'
    | '/settings/data-migration'
    | '/settings/domains'
    | '/settings/gift-options'
    | '/settings/integrations'
    | '/settings/inventory'
    | '/settings/invoices'
    | '/settings/languages'
    | '/settings/localization'
    | '/settings/markets'
    | '/settings/messaging'
    | '/settings/metafield-definitions'
    | '/settings/notifications'
    | '/settings/operations'
    | '/settings/order-customizations'
    | '/settings/payment-methods'
    | '/settings/profile'
    | '/settings/return-policy'
    | '/settings/scheduling'
    | '/settings/security'
    | '/settings/shipping'
    | '/settings/staff'
    | '/settings/store'
    | '/settings/tax'
    | '/settings/testimonials'
    | '/stock-locations/$id'
    | '/stock-locations/new'
    | '/catalog/labels/$id'
    | '/catalog/labels/new'
    | '/catalog/labels/settings'
    | '/customers/$id/edit'
    | '/customers/automations/$id'
    | '/customers/automations/new'
    | '/customers/groups/$id'
    | '/customers/groups/new'
    | '/customers/reviews/$id'
    | '/inventory/purchase-orders/$id'
    | '/inventory/purchase-orders/new'
    | '/inventory/purchase-orders/vendors'
    | '/inventory/transfers/$id'
    | '/inventory/transfers/new'
    | '/marketing/affiliates/$id'
    | '/marketing/affiliates/new'
    | '/marketing/affiliates/settings'
    | '/marketing/automations/$id'
    | '/marketing/automations/new'
    | '/marketing/automations/secrets'
    | '/marketing/cashback/$id'
    | '/marketing/cashback/new'
    | '/marketing/catalog-discounts/$id'
    | '/marketing/catalog-discounts/new'
    | '/marketing/discounts/$id'
    | '/marketing/discounts/new'
    | '/marketing/referrals/settings'
    | '/orders/$id/modify'
    | '/orders/automations/$id'
    | '/orders/automations/new'
    | '/orders/draft/$id'
    | '/orders/returns/$id'
    | '/products/automations/$id'
    | '/products/automations/new'
    | '/sales-channels/mobile-app/design'
    | '/sales-channels/mobile-app/homepage'
    | '/sales-channels/mobile-app/identity'
    | '/sales-channels/mobile-app/notifications'
    | '/sales-channels/mobile-app/settings'
    | '/sales-channels/online-store/design'
    | '/sales-channels/online-store/product-experience'
    | '/settings/apps/$appCode'
    | '/settings/billing/add-ons'
    | '/settings/billing/invoices'
    | '/settings/billing/payment-methods'
    | '/settings/messaging/logs'
    | '/settings/messaging/whatsapp'
    | '/settings/metafield-definitions/$id'
    | '/settings/metafield-definitions/new'
    | '/settings/payment-methods/activate'
    | '/settings/payment-methods/bank-transfer'
    | '/settings/scheduling/$id'
    | '/settings/shipping/$carrierCode'
    | '/settings/shipping/kayn-ship'
    | '/settings/shipping/manual'
    | '/settings/staff/$id'
    | '/settings/staff/invite'
    | '/customers/automations/$id/logs'
    | '/customers/groups/$id/edit'
    | '/inventory/purchase-orders/vendors/$id'
    | '/inventory/purchase-orders/vendors/new'
    | '/marketing/automations/$id/logs'
    | '/orders/automations/$id/logs'
    | '/products/automations/$id/logs'
    | '/settings/messaging/whatsapp/templates'
    | '/settings/shipping/kayn-ship/wallet'
  id:
    | '__root__'
    | '/'
    | '/finance'
    | '/reports'
    | '/sales-channels/mobile-app'
    | '/accept-invite/'
    | '/attributes/'
    | '/blog/'
    | '/brands/'
    | '/capabilities/'
    | '/categories/'
    | '/collections/'
    | '/customers/'
    | '/facets/'
    | '/filters/'
    | '/finance/'
    | '/gift-cards/'
    | '/inventory/'
    | '/login/'
    | '/marketing/'
    | '/notifications/'
    | '/onboarding/'
    | '/orders/'
    | '/pages/'
    | '/product-properties/'
    | '/product-templates/'
    | '/products/'
    | '/reports/'
    | '/reset-password/'
    | '/sales-channels/'
    | '/select-store/'
    | '/settings/'
    | '/signup/'
    | '/stock-locations/'
    | '/verify-2fa/'
    | '/verify-email/'
    | '/attributes/$id/'
    | '/blog/$id/'
    | '/blog/categories/'
    | '/blog/new/'
    | '/brands/$id/'
    | '/brands/new/'
    | '/catalog/labels/'
    | '/categories/$id/'
    | '/categories/new/'
    | '/collections/$id/'
    | '/collections/new/'
    | '/customers/$id/'
    | '/customers/automations/'
    | '/customers/groups/'
    | '/customers/new/'
    | '/customers/questions/'
    | '/customers/review-requests/'
    | '/customers/reviews/'
    | '/customers/rfm/'
    | '/customers/smart-segments/'
    | '/facets/$id/'
    | '/facets/new/'
    | '/filters/$id/'
    | '/filters/new/'
    | '/finance/transactions/'
    | '/gift-cards/$id/'
    | '/gift-cards/settings/'
    | '/inventory/history/'
    | '/inventory/purchase-orders/'
    | '/inventory/transfers/'
    | '/marketing/abandoned-carts/'
    | '/marketing/affiliates/'
    | '/marketing/announcements/'
    | '/marketing/automations/'
    | '/marketing/back-in-stock/'
    | '/marketing/calendar/'
    | '/marketing/cashback/'
    | '/marketing/catalog-discounts/'
    | '/marketing/discounts/'
    | '/marketing/loyalty/'
    | '/marketing/product-feeds/'
    | '/marketing/push-notifications/'
    | '/marketing/referrals/'
    | '/marketing/repurchase-reminders/'
    | '/marketing/sales-boosters/'
    | '/marketing/segments/'
    | '/marketing/seo/'
    | '/orders/$id/'
    | '/orders/automations/'
    | '/orders/drafts/'
    | '/orders/fulfilment/'
    | '/orders/invoices/'
    | '/orders/new/'
    | '/orders/returns/'
    | '/orders/shipments/'
    | '/pages/$id/'
    | '/pages/new/'
    | '/products/$id/'
    | '/products/automations/'
    | '/products/bulk-edit/'
    | '/products/new/'
    | '/reports/customers/'
    | '/reports/financial/'
    | '/reports/loyalty/'
    | '/reports/orders/'
    | '/reports/products/'
    | '/reports/sales/'
    | '/sales-channels/mobile-app/'
    | '/sales-channels/online-store/'
    | '/sales-channels/pos/'
    | '/settings/apps/'
    | '/settings/billing/'
    | '/settings/checkout-restrictions/'
    | '/settings/checkout-risk/'
    | '/settings/checkout/'
    | '/settings/content-blocks/'
    | '/settings/data-migration/'
    | '/settings/domains/'
    | '/settings/gift-options/'
    | '/settings/integrations/'
    | '/settings/inventory/'
    | '/settings/invoices/'
    | '/settings/languages/'
    | '/settings/localization/'
    | '/settings/markets/'
    | '/settings/messaging/'
    | '/settings/metafield-definitions/'
    | '/settings/notifications/'
    | '/settings/operations/'
    | '/settings/order-customizations/'
    | '/settings/payment-methods/'
    | '/settings/profile/'
    | '/settings/return-policy/'
    | '/settings/scheduling/'
    | '/settings/security/'
    | '/settings/shipping/'
    | '/settings/staff/'
    | '/settings/store/'
    | '/settings/tax/'
    | '/settings/testimonials/'
    | '/stock-locations/$id/'
    | '/stock-locations/new/'
    | '/catalog/labels/$id/'
    | '/catalog/labels/new/'
    | '/catalog/labels/settings/'
    | '/customers/$id/edit/'
    | '/customers/automations/$id/'
    | '/customers/automations/new/'
    | '/customers/groups/$id/'
    | '/customers/groups/new/'
    | '/customers/reviews/$id/'
    | '/inventory/purchase-orders/$id/'
    | '/inventory/purchase-orders/new/'
    | '/inventory/purchase-orders/vendors/'
    | '/inventory/transfers/$id/'
    | '/inventory/transfers/new/'
    | '/marketing/affiliates/$id/'
    | '/marketing/affiliates/new/'
    | '/marketing/affiliates/settings/'
    | '/marketing/automations/$id/'
    | '/marketing/automations/new/'
    | '/marketing/automations/secrets/'
    | '/marketing/cashback/$id/'
    | '/marketing/cashback/new/'
    | '/marketing/catalog-discounts/$id/'
    | '/marketing/catalog-discounts/new/'
    | '/marketing/discounts/$id/'
    | '/marketing/discounts/new/'
    | '/marketing/referrals/settings/'
    | '/orders/$id/modify/'
    | '/orders/automations/$id/'
    | '/orders/automations/new/'
    | '/orders/draft/$id/'
    | '/orders/returns/$id/'
    | '/products/automations/$id/'
    | '/products/automations/new/'
    | '/sales-channels/mobile-app/design/'
    | '/sales-channels/mobile-app/homepage/'
    | '/sales-channels/mobile-app/identity/'
    | '/sales-channels/mobile-app/notifications/'
    | '/sales-channels/mobile-app/settings/'
    | '/sales-channels/online-store/design/'
    | '/sales-channels/online-store/product-experience/'
    | '/settings/apps/$appCode/'
    | '/settings/billing/add-ons/'
    | '/settings/billing/invoices/'
    | '/settings/billing/payment-methods/'
    | '/settings/messaging/logs/'
    | '/settings/messaging/whatsapp/'
    | '/settings/metafield-definitions/$id/'
    | '/settings/metafield-definitions/new/'
    | '/settings/payment-methods/activate/'
    | '/settings/payment-methods/bank-transfer/'
    | '/settings/scheduling/$id/'
    | '/settings/shipping/$carrierCode/'
    | '/settings/shipping/kayn-ship/'
    | '/settings/shipping/manual/'
    | '/settings/staff/$id/'
    | '/settings/staff/invite/'
    | '/customers/automations/$id/logs/'
    | '/customers/groups/$id/edit/'
    | '/inventory/purchase-orders/vendors/$id/'
    | '/inventory/purchase-orders/vendors/new/'
    | '/marketing/automations/$id/logs/'
    | '/orders/automations/$id/logs/'
    | '/products/automations/$id/logs/'
    | '/settings/messaging/whatsapp/templates/'
    | '/settings/shipping/kayn-ship/wallet/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FinanceRouteRoute: typeof FinanceRouteRouteWithChildren
  ReportsRouteRoute: typeof ReportsRouteRouteWithChildren
  SalesChannelsMobileAppRouteRoute: typeof SalesChannelsMobileAppRouteRouteWithChildren
  AcceptInviteIndexRoute: typeof AcceptInviteIndexRoute
  AttributesIndexRoute: typeof AttributesIndexRoute
  BlogIndexRoute: typeof BlogIndexRoute
  BrandsIndexRoute: typeof BrandsIndexRoute
  CapabilitiesIndexRoute: typeof CapabilitiesIndexRoute
  CategoriesIndexRoute: typeof CategoriesIndexRoute
  CollectionsIndexRoute: typeof CollectionsIndexRoute
  CustomersIndexRoute: typeof CustomersIndexRoute
  FacetsIndexRoute: typeof FacetsIndexRoute
  FiltersIndexRoute: typeof FiltersIndexRoute
  GiftCardsIndexRoute: typeof GiftCardsIndexRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  PagesIndexRoute: typeof PagesIndexRoute
  ProductPropertiesIndexRoute: typeof ProductPropertiesIndexRoute
  ProductTemplatesIndexRoute: typeof ProductTemplatesIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  SalesChannelsIndexRoute: typeof SalesChannelsIndexRoute
  SelectStoreIndexRoute: typeof SelectStoreIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SignupIndexRoute: typeof SignupIndexRoute
  StockLocationsIndexRoute: typeof StockLocationsIndexRoute
  Verify2faIndexRoute: typeof Verify2faIndexRoute
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute
  AttributesIdIndexRoute: typeof AttributesIdIndexRoute
  BlogIdIndexRoute: typeof BlogIdIndexRoute
  BlogCategoriesIndexRoute: typeof BlogCategoriesIndexRoute
  BlogNewIndexRoute: typeof BlogNewIndexRoute
  BrandsIdIndexRoute: typeof BrandsIdIndexRoute
  BrandsNewIndexRoute: typeof BrandsNewIndexRoute
  CatalogLabelsIndexRoute: typeof CatalogLabelsIndexRoute
  CategoriesIdIndexRoute: typeof CategoriesIdIndexRoute
  CategoriesNewIndexRoute: typeof CategoriesNewIndexRoute
  CollectionsIdIndexRoute: typeof CollectionsIdIndexRoute
  CollectionsNewIndexRoute: typeof CollectionsNewIndexRoute
  CustomersIdIndexRoute: typeof CustomersIdIndexRoute
  CustomersAutomationsIndexRoute: typeof CustomersAutomationsIndexRoute
  CustomersGroupsIndexRoute: typeof CustomersGroupsIndexRoute
  CustomersNewIndexRoute: typeof CustomersNewIndexRoute
  CustomersQuestionsIndexRoute: typeof CustomersQuestionsIndexRoute
  CustomersReviewRequestsIndexRoute: typeof CustomersReviewRequestsIndexRoute
  CustomersReviewsIndexRoute: typeof CustomersReviewsIndexRoute
  CustomersRfmIndexRoute: typeof CustomersRfmIndexRoute
  CustomersSmartSegmentsIndexRoute: typeof CustomersSmartSegmentsIndexRoute
  FacetsIdIndexRoute: typeof FacetsIdIndexRoute
  FacetsNewIndexRoute: typeof FacetsNewIndexRoute
  FiltersIdIndexRoute: typeof FiltersIdIndexRoute
  FiltersNewIndexRoute: typeof FiltersNewIndexRoute
  GiftCardsIdIndexRoute: typeof GiftCardsIdIndexRoute
  GiftCardsSettingsIndexRoute: typeof GiftCardsSettingsIndexRoute
  InventoryHistoryIndexRoute: typeof InventoryHistoryIndexRoute
  InventoryPurchaseOrdersIndexRoute: typeof InventoryPurchaseOrdersIndexRoute
  InventoryTransfersIndexRoute: typeof InventoryTransfersIndexRoute
  MarketingAbandonedCartsIndexRoute: typeof MarketingAbandonedCartsIndexRoute
  MarketingAffiliatesIndexRoute: typeof MarketingAffiliatesIndexRoute
  MarketingAnnouncementsIndexRoute: typeof MarketingAnnouncementsIndexRoute
  MarketingAutomationsIndexRoute: typeof MarketingAutomationsIndexRoute
  MarketingBackInStockIndexRoute: typeof MarketingBackInStockIndexRoute
  MarketingCalendarIndexRoute: typeof MarketingCalendarIndexRoute
  MarketingCashbackIndexRoute: typeof MarketingCashbackIndexRoute
  MarketingCatalogDiscountsIndexRoute: typeof MarketingCatalogDiscountsIndexRoute
  MarketingDiscountsIndexRoute: typeof MarketingDiscountsIndexRoute
  MarketingLoyaltyIndexRoute: typeof MarketingLoyaltyIndexRoute
  MarketingProductFeedsIndexRoute: typeof MarketingProductFeedsIndexRoute
  MarketingPushNotificationsIndexRoute: typeof MarketingPushNotificationsIndexRoute
  MarketingReferralsIndexRoute: typeof MarketingReferralsIndexRoute
  MarketingRepurchaseRemindersIndexRoute: typeof MarketingRepurchaseRemindersIndexRoute
  MarketingSalesBoostersIndexRoute: typeof MarketingSalesBoostersIndexRoute
  MarketingSegmentsIndexRoute: typeof MarketingSegmentsIndexRoute
  MarketingSeoIndexRoute: typeof MarketingSeoIndexRoute
  OrdersIdIndexRoute: typeof OrdersIdIndexRoute
  OrdersAutomationsIndexRoute: typeof OrdersAutomationsIndexRoute
  OrdersDraftsIndexRoute: typeof OrdersDraftsIndexRoute
  OrdersFulfilmentIndexRoute: typeof OrdersFulfilmentIndexRoute
  OrdersInvoicesIndexRoute: typeof OrdersInvoicesIndexRoute
  OrdersNewIndexRoute: typeof OrdersNewIndexRoute
  OrdersReturnsIndexRoute: typeof OrdersReturnsIndexRoute
  OrdersShipmentsIndexRoute: typeof OrdersShipmentsIndexRoute
  PagesIdIndexRoute: typeof PagesIdIndexRoute
  PagesNewIndexRoute: typeof PagesNewIndexRoute
  ProductsIdIndexRoute: typeof ProductsIdIndexRoute
  ProductsAutomationsIndexRoute: typeof ProductsAutomationsIndexRoute
  ProductsBulkEditIndexRoute: typeof ProductsBulkEditIndexRoute
  ProductsNewIndexRoute: typeof ProductsNewIndexRoute
  SalesChannelsOnlineStoreIndexRoute: typeof SalesChannelsOnlineStoreIndexRoute
  SalesChannelsPosIndexRoute: typeof SalesChannelsPosIndexRoute
  SettingsAppsIndexRoute: typeof SettingsAppsIndexRoute
  SettingsBillingIndexRoute: typeof SettingsBillingIndexRoute
  SettingsCheckoutRestrictionsIndexRoute: typeof SettingsCheckoutRestrictionsIndexRoute
  SettingsCheckoutRiskIndexRoute: typeof SettingsCheckoutRiskIndexRoute
  SettingsCheckoutIndexRoute: typeof SettingsCheckoutIndexRoute
  SettingsContentBlocksIndexRoute: typeof SettingsContentBlocksIndexRoute
  SettingsDataMigrationIndexRoute: typeof SettingsDataMigrationIndexRoute
  SettingsDomainsIndexRoute: typeof SettingsDomainsIndexRoute
  SettingsGiftOptionsIndexRoute: typeof SettingsGiftOptionsIndexRoute
  SettingsIntegrationsIndexRoute: typeof SettingsIntegrationsIndexRoute
  SettingsInventoryIndexRoute: typeof SettingsInventoryIndexRoute
  SettingsInvoicesIndexRoute: typeof SettingsInvoicesIndexRoute
  SettingsLanguagesIndexRoute: typeof SettingsLanguagesIndexRoute
  SettingsLocalizationIndexRoute: typeof SettingsLocalizationIndexRoute
  SettingsMarketsIndexRoute: typeof SettingsMarketsIndexRoute
  SettingsMessagingIndexRoute: typeof SettingsMessagingIndexRoute
  SettingsMetafieldDefinitionsIndexRoute: typeof SettingsMetafieldDefinitionsIndexRoute
  SettingsNotificationsIndexRoute: typeof SettingsNotificationsIndexRoute
  SettingsOperationsIndexRoute: typeof SettingsOperationsIndexRoute
  SettingsOrderCustomizationsIndexRoute: typeof SettingsOrderCustomizationsIndexRoute
  SettingsPaymentMethodsIndexRoute: typeof SettingsPaymentMethodsIndexRoute
  SettingsProfileIndexRoute: typeof SettingsProfileIndexRoute
  SettingsReturnPolicyIndexRoute: typeof SettingsReturnPolicyIndexRoute
  SettingsSchedulingIndexRoute: typeof SettingsSchedulingIndexRoute
  SettingsSecurityIndexRoute: typeof SettingsSecurityIndexRoute
  SettingsShippingIndexRoute: typeof SettingsShippingIndexRoute
  SettingsStaffIndexRoute: typeof SettingsStaffIndexRoute
  SettingsStoreIndexRoute: typeof SettingsStoreIndexRoute
  SettingsTaxIndexRoute: typeof SettingsTaxIndexRoute
  SettingsTestimonialsIndexRoute: typeof SettingsTestimonialsIndexRoute
  StockLocationsIdIndexRoute: typeof StockLocationsIdIndexRoute
  StockLocationsNewIndexRoute: typeof StockLocationsNewIndexRoute
  CatalogLabelsIdIndexRoute: typeof CatalogLabelsIdIndexRoute
  CatalogLabelsNewIndexRoute: typeof CatalogLabelsNewIndexRoute
  CatalogLabelsSettingsIndexRoute: typeof CatalogLabelsSettingsIndexRoute
  CustomersIdEditIndexRoute: typeof CustomersIdEditIndexRoute
  CustomersAutomationsIdIndexRoute: typeof CustomersAutomationsIdIndexRoute
  CustomersAutomationsNewIndexRoute: typeof CustomersAutomationsNewIndexRoute
  CustomersGroupsIdIndexRoute: typeof CustomersGroupsIdIndexRoute
  CustomersGroupsNewIndexRoute: typeof CustomersGroupsNewIndexRoute
  CustomersReviewsIdIndexRoute: typeof CustomersReviewsIdIndexRoute
  InventoryPurchaseOrdersIdIndexRoute: typeof InventoryPurchaseOrdersIdIndexRoute
  InventoryPurchaseOrdersNewIndexRoute: typeof InventoryPurchaseOrdersNewIndexRoute
  InventoryPurchaseOrdersVendorsIndexRoute: typeof InventoryPurchaseOrdersVendorsIndexRoute
  InventoryTransfersIdIndexRoute: typeof InventoryTransfersIdIndexRoute
  InventoryTransfersNewIndexRoute: typeof InventoryTransfersNewIndexRoute
  MarketingAffiliatesIdIndexRoute: typeof MarketingAffiliatesIdIndexRoute
  MarketingAffiliatesNewIndexRoute: typeof MarketingAffiliatesNewIndexRoute
  MarketingAffiliatesSettingsIndexRoute: typeof MarketingAffiliatesSettingsIndexRoute
  MarketingAutomationsIdIndexRoute: typeof MarketingAutomationsIdIndexRoute
  MarketingAutomationsNewIndexRoute: typeof MarketingAutomationsNewIndexRoute
  MarketingAutomationsSecretsIndexRoute: typeof MarketingAutomationsSecretsIndexRoute
  MarketingCashbackIdIndexRoute: typeof MarketingCashbackIdIndexRoute
  MarketingCashbackNewIndexRoute: typeof MarketingCashbackNewIndexRoute
  MarketingCatalogDiscountsIdIndexRoute: typeof MarketingCatalogDiscountsIdIndexRoute
  MarketingCatalogDiscountsNewIndexRoute: typeof MarketingCatalogDiscountsNewIndexRoute
  MarketingDiscountsIdIndexRoute: typeof MarketingDiscountsIdIndexRoute
  MarketingDiscountsNewIndexRoute: typeof MarketingDiscountsNewIndexRoute
  MarketingReferralsSettingsIndexRoute: typeof MarketingReferralsSettingsIndexRoute
  OrdersIdModifyIndexRoute: typeof OrdersIdModifyIndexRoute
  OrdersAutomationsIdIndexRoute: typeof OrdersAutomationsIdIndexRoute
  OrdersAutomationsNewIndexRoute: typeof OrdersAutomationsNewIndexRoute
  OrdersDraftIdIndexRoute: typeof OrdersDraftIdIndexRoute
  OrdersReturnsIdIndexRoute: typeof OrdersReturnsIdIndexRoute
  ProductsAutomationsIdIndexRoute: typeof ProductsAutomationsIdIndexRoute
  ProductsAutomationsNewIndexRoute: typeof ProductsAutomationsNewIndexRoute
  SalesChannelsOnlineStoreDesignIndexRoute: typeof SalesChannelsOnlineStoreDesignIndexRoute
  SalesChannelsOnlineStoreProductExperienceIndexRoute: typeof SalesChannelsOnlineStoreProductExperienceIndexRoute
  SettingsAppsAppCodeIndexRoute: typeof SettingsAppsAppCodeIndexRoute
  SettingsBillingAddOnsIndexRoute: typeof SettingsBillingAddOnsIndexRoute
  SettingsBillingInvoicesIndexRoute: typeof SettingsBillingInvoicesIndexRoute
  SettingsBillingPaymentMethodsIndexRoute: typeof SettingsBillingPaymentMethodsIndexRoute
  SettingsMessagingLogsIndexRoute: typeof SettingsMessagingLogsIndexRoute
  SettingsMessagingWhatsappIndexRoute: typeof SettingsMessagingWhatsappIndexRoute
  SettingsMetafieldDefinitionsIdIndexRoute: typeof SettingsMetafieldDefinitionsIdIndexRoute
  SettingsMetafieldDefinitionsNewIndexRoute: typeof SettingsMetafieldDefinitionsNewIndexRoute
  SettingsPaymentMethodsActivateIndexRoute: typeof SettingsPaymentMethodsActivateIndexRoute
  SettingsPaymentMethodsBankTransferIndexRoute: typeof SettingsPaymentMethodsBankTransferIndexRoute
  SettingsSchedulingIdIndexRoute: typeof SettingsSchedulingIdIndexRoute
  SettingsShippingCarrierCodeIndexRoute: typeof SettingsShippingCarrierCodeIndexRoute
  SettingsShippingKaynShipIndexRoute: typeof SettingsShippingKaynShipIndexRoute
  SettingsShippingManualIndexRoute: typeof SettingsShippingManualIndexRoute
  SettingsStaffIdIndexRoute: typeof SettingsStaffIdIndexRoute
  SettingsStaffInviteIndexRoute: typeof SettingsStaffInviteIndexRoute
  CustomersAutomationsIdLogsIndexRoute: typeof CustomersAutomationsIdLogsIndexRoute
  CustomersGroupsIdEditIndexRoute: typeof CustomersGroupsIdEditIndexRoute
  InventoryPurchaseOrdersVendorsIdIndexRoute: typeof InventoryPurchaseOrdersVendorsIdIndexRoute
  InventoryPurchaseOrdersVendorsNewIndexRoute: typeof InventoryPurchaseOrdersVendorsNewIndexRoute
  MarketingAutomationsIdLogsIndexRoute: typeof MarketingAutomationsIdLogsIndexRoute
  OrdersAutomationsIdLogsIndexRoute: typeof OrdersAutomationsIdLogsIndexRoute
  ProductsAutomationsIdLogsIndexRoute: typeof ProductsAutomationsIdLogsIndexRoute
  SettingsMessagingWhatsappTemplatesIndexRoute: typeof SettingsMessagingWhatsappTemplatesIndexRoute
  SettingsShippingKaynShipWalletIndexRoute: typeof SettingsShippingKaynShipWalletIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/': {
      id: '/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email/'
      preLoaderRoute: typeof VerifyEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-2fa/': {
      id: '/verify-2fa/'
      path: '/verify-2fa'
      fullPath: '/verify-2fa/'
      preLoaderRoute: typeof Verify2faIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stock-locations/': {
      id: '/stock-locations/'
      path: '/stock-locations'
      fullPath: '/stock-locations/'
      preLoaderRoute: typeof StockLocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/': {
      id: '/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-store/': {
      id: '/select-store/'
      path: '/select-store'
      fullPath: '/select-store/'
      preLoaderRoute: typeof SelectStoreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/': {
      id: '/sales-channels/'
      path: '/sales-channels'
      fullPath: '/sales-channels/'
      preLoaderRoute: typeof SalesChannelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product-templates/': {
      id: '/product-templates/'
      path: '/product-templates'
      fullPath: '/product-templates/'
      preLoaderRoute: typeof ProductTemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product-properties/': {
      id: '/product-properties/'
      path: '/product-properties'
      fullPath: '/product-properties/'
      preLoaderRoute: typeof ProductPropertiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/': {
      id: '/pages/'
      path: '/pages'
      fullPath: '/pages/'
      preLoaderRoute: typeof PagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/': {
      id: '/marketing/'
      path: '/marketing'
      fullPath: '/marketing/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift-cards/': {
      id: '/gift-cards/'
      path: '/gift-cards'
      fullPath: '/gift-cards/'
      preLoaderRoute: typeof GiftCardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/': {
      id: '/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof FinanceIndexRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/filters/': {
      id: '/filters/'
      path: '/filters'
      fullPath: '/filters/'
      preLoaderRoute: typeof FiltersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facets/': {
      id: '/facets/'
      path: '/facets'
      fullPath: '/facets/'
      preLoaderRoute: typeof FacetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/': {
      id: '/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof CustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/': {
      id: '/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof CollectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories/': {
      id: '/categories/'
      path: '/categories'
      fullPath: '/categories/'
      preLoaderRoute: typeof CategoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capabilities/': {
      id: '/capabilities/'
      path: '/capabilities'
      fullPath: '/capabilities/'
      preLoaderRoute: typeof CapabilitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/': {
      id: '/brands/'
      path: '/brands'
      fullPath: '/brands/'
      preLoaderRoute: typeof BrandsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attributes/': {
      id: '/attributes/'
      path: '/attributes'
      fullPath: '/attributes/'
      preLoaderRoute: typeof AttributesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite/': {
      id: '/accept-invite/'
      path: '/accept-invite'
      fullPath: '/accept-invite/'
      preLoaderRoute: typeof AcceptInviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/mobile-app': {
      id: '/sales-channels/mobile-app'
      path: '/sales-channels/mobile-app'
      fullPath: '/sales-channels/mobile-app'
      preLoaderRoute: typeof SalesChannelsMobileAppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stock-locations/new/': {
      id: '/stock-locations/new/'
      path: '/stock-locations/new'
      fullPath: '/stock-locations/new/'
      preLoaderRoute: typeof StockLocationsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stock-locations/$id/': {
      id: '/stock-locations/$id/'
      path: '/stock-locations/$id'
      fullPath: '/stock-locations/$id/'
      preLoaderRoute: typeof StockLocationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/testimonials/': {
      id: '/settings/testimonials/'
      path: '/settings/testimonials'
      fullPath: '/settings/testimonials/'
      preLoaderRoute: typeof SettingsTestimonialsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tax/': {
      id: '/settings/tax/'
      path: '/settings/tax'
      fullPath: '/settings/tax/'
      preLoaderRoute: typeof SettingsTaxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/store/': {
      id: '/settings/store/'
      path: '/settings/store'
      fullPath: '/settings/store/'
      preLoaderRoute: typeof SettingsStoreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/staff/': {
      id: '/settings/staff/'
      path: '/settings/staff'
      fullPath: '/settings/staff/'
      preLoaderRoute: typeof SettingsStaffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/shipping/': {
      id: '/settings/shipping/'
      path: '/settings/shipping'
      fullPath: '/settings/shipping/'
      preLoaderRoute: typeof SettingsShippingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/security/': {
      id: '/settings/security/'
      path: '/settings/security'
      fullPath: '/settings/security/'
      preLoaderRoute: typeof SettingsSecurityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/scheduling/': {
      id: '/settings/scheduling/'
      path: '/settings/scheduling'
      fullPath: '/settings/scheduling/'
      preLoaderRoute: typeof SettingsSchedulingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/return-policy/': {
      id: '/settings/return-policy/'
      path: '/settings/return-policy'
      fullPath: '/settings/return-policy/'
      preLoaderRoute: typeof SettingsReturnPolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/profile/': {
      id: '/settings/profile/'
      path: '/settings/profile'
      fullPath: '/settings/profile/'
      preLoaderRoute: typeof SettingsProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payment-methods/': {
      id: '/settings/payment-methods/'
      path: '/settings/payment-methods'
      fullPath: '/settings/payment-methods/'
      preLoaderRoute: typeof SettingsPaymentMethodsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/order-customizations/': {
      id: '/settings/order-customizations/'
      path: '/settings/order-customizations'
      fullPath: '/settings/order-customizations/'
      preLoaderRoute: typeof SettingsOrderCustomizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/operations/': {
      id: '/settings/operations/'
      path: '/settings/operations'
      fullPath: '/settings/operations/'
      preLoaderRoute: typeof SettingsOperationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications/': {
      id: '/settings/notifications/'
      path: '/settings/notifications'
      fullPath: '/settings/notifications/'
      preLoaderRoute: typeof SettingsNotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metafield-definitions/': {
      id: '/settings/metafield-definitions/'
      path: '/settings/metafield-definitions'
      fullPath: '/settings/metafield-definitions/'
      preLoaderRoute: typeof SettingsMetafieldDefinitionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/messaging/': {
      id: '/settings/messaging/'
      path: '/settings/messaging'
      fullPath: '/settings/messaging/'
      preLoaderRoute: typeof SettingsMessagingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/markets/': {
      id: '/settings/markets/'
      path: '/settings/markets'
      fullPath: '/settings/markets/'
      preLoaderRoute: typeof SettingsMarketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/localization/': {
      id: '/settings/localization/'
      path: '/settings/localization'
      fullPath: '/settings/localization/'
      preLoaderRoute: typeof SettingsLocalizationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/languages/': {
      id: '/settings/languages/'
      path: '/settings/languages'
      fullPath: '/settings/languages/'
      preLoaderRoute: typeof SettingsLanguagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/invoices/': {
      id: '/settings/invoices/'
      path: '/settings/invoices'
      fullPath: '/settings/invoices/'
      preLoaderRoute: typeof SettingsInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/inventory/': {
      id: '/settings/inventory/'
      path: '/settings/inventory'
      fullPath: '/settings/inventory/'
      preLoaderRoute: typeof SettingsInventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations/': {
      id: '/settings/integrations/'
      path: '/settings/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof SettingsIntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/gift-options/': {
      id: '/settings/gift-options/'
      path: '/settings/gift-options'
      fullPath: '/settings/gift-options/'
      preLoaderRoute: typeof SettingsGiftOptionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/domains/': {
      id: '/settings/domains/'
      path: '/settings/domains'
      fullPath: '/settings/domains/'
      preLoaderRoute: typeof SettingsDomainsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/data-migration/': {
      id: '/settings/data-migration/'
      path: '/settings/data-migration'
      fullPath: '/settings/data-migration/'
      preLoaderRoute: typeof SettingsDataMigrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/content-blocks/': {
      id: '/settings/content-blocks/'
      path: '/settings/content-blocks'
      fullPath: '/settings/content-blocks/'
      preLoaderRoute: typeof SettingsContentBlocksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/checkout/': {
      id: '/settings/checkout/'
      path: '/settings/checkout'
      fullPath: '/settings/checkout/'
      preLoaderRoute: typeof SettingsCheckoutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/checkout-risk/': {
      id: '/settings/checkout-risk/'
      path: '/settings/checkout-risk'
      fullPath: '/settings/checkout-risk/'
      preLoaderRoute: typeof SettingsCheckoutRiskIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/checkout-restrictions/': {
      id: '/settings/checkout-restrictions/'
      path: '/settings/checkout-restrictions'
      fullPath: '/settings/checkout-restrictions/'
      preLoaderRoute: typeof SettingsCheckoutRestrictionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing/': {
      id: '/settings/billing/'
      path: '/settings/billing'
      fullPath: '/settings/billing/'
      preLoaderRoute: typeof SettingsBillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/apps/': {
      id: '/settings/apps/'
      path: '/settings/apps'
      fullPath: '/settings/apps/'
      preLoaderRoute: typeof SettingsAppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/pos/': {
      id: '/sales-channels/pos/'
      path: '/sales-channels/pos'
      fullPath: '/sales-channels/pos/'
      preLoaderRoute: typeof SalesChannelsPosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/online-store/': {
      id: '/sales-channels/online-store/'
      path: '/sales-channels/online-store'
      fullPath: '/sales-channels/online-store/'
      preLoaderRoute: typeof SalesChannelsOnlineStoreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/mobile-app/': {
      id: '/sales-channels/mobile-app/'
      path: '/'
      fullPath: '/sales-channels/mobile-app/'
      preLoaderRoute: typeof SalesChannelsMobileAppIndexRouteImport
      parentRoute: typeof SalesChannelsMobileAppRouteRoute
    }
    '/reports/sales/': {
      id: '/reports/sales/'
      path: '/sales'
      fullPath: '/reports/sales/'
      preLoaderRoute: typeof ReportsSalesIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/reports/products/': {
      id: '/reports/products/'
      path: '/products'
      fullPath: '/reports/products/'
      preLoaderRoute: typeof ReportsProductsIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/reports/orders/': {
      id: '/reports/orders/'
      path: '/orders'
      fullPath: '/reports/orders/'
      preLoaderRoute: typeof ReportsOrdersIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/reports/loyalty/': {
      id: '/reports/loyalty/'
      path: '/loyalty'
      fullPath: '/reports/loyalty/'
      preLoaderRoute: typeof ReportsLoyaltyIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/reports/financial/': {
      id: '/reports/financial/'
      path: '/financial'
      fullPath: '/reports/financial/'
      preLoaderRoute: typeof ReportsFinancialIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/reports/customers/': {
      id: '/reports/customers/'
      path: '/customers'
      fullPath: '/reports/customers/'
      preLoaderRoute: typeof ReportsCustomersIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/products/new/': {
      id: '/products/new/'
      path: '/products/new'
      fullPath: '/products/new/'
      preLoaderRoute: typeof ProductsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/bulk-edit/': {
      id: '/products/bulk-edit/'
      path: '/products/bulk-edit'
      fullPath: '/products/bulk-edit/'
      preLoaderRoute: typeof ProductsBulkEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/automations/': {
      id: '/products/automations/'
      path: '/products/automations'
      fullPath: '/products/automations/'
      preLoaderRoute: typeof ProductsAutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$id/': {
      id: '/products/$id/'
      path: '/products/$id'
      fullPath: '/products/$id/'
      preLoaderRoute: typeof ProductsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/new/': {
      id: '/pages/new/'
      path: '/pages/new'
      fullPath: '/pages/new/'
      preLoaderRoute: typeof PagesNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/$id/': {
      id: '/pages/$id/'
      path: '/pages/$id'
      fullPath: '/pages/$id/'
      preLoaderRoute: typeof PagesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/shipments/': {
      id: '/orders/shipments/'
      path: '/orders/shipments'
      fullPath: '/orders/shipments/'
      preLoaderRoute: typeof OrdersShipmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/returns/': {
      id: '/orders/returns/'
      path: '/orders/returns'
      fullPath: '/orders/returns/'
      preLoaderRoute: typeof OrdersReturnsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/new/': {
      id: '/orders/new/'
      path: '/orders/new'
      fullPath: '/orders/new/'
      preLoaderRoute: typeof OrdersNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/invoices/': {
      id: '/orders/invoices/'
      path: '/orders/invoices'
      fullPath: '/orders/invoices/'
      preLoaderRoute: typeof OrdersInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/fulfilment/': {
      id: '/orders/fulfilment/'
      path: '/orders/fulfilment'
      fullPath: '/orders/fulfilment/'
      preLoaderRoute: typeof OrdersFulfilmentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/drafts/': {
      id: '/orders/drafts/'
      path: '/orders/drafts'
      fullPath: '/orders/drafts/'
      preLoaderRoute: typeof OrdersDraftsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/automations/': {
      id: '/orders/automations/'
      path: '/orders/automations'
      fullPath: '/orders/automations/'
      preLoaderRoute: typeof OrdersAutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$id/': {
      id: '/orders/$id/'
      path: '/orders/$id'
      fullPath: '/orders/$id/'
      preLoaderRoute: typeof OrdersIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/seo/': {
      id: '/marketing/seo/'
      path: '/marketing/seo'
      fullPath: '/marketing/seo/'
      preLoaderRoute: typeof MarketingSeoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/segments/': {
      id: '/marketing/segments/'
      path: '/marketing/segments'
      fullPath: '/marketing/segments/'
      preLoaderRoute: typeof MarketingSegmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/sales-boosters/': {
      id: '/marketing/sales-boosters/'
      path: '/marketing/sales-boosters'
      fullPath: '/marketing/sales-boosters/'
      preLoaderRoute: typeof MarketingSalesBoostersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/repurchase-reminders/': {
      id: '/marketing/repurchase-reminders/'
      path: '/marketing/repurchase-reminders'
      fullPath: '/marketing/repurchase-reminders/'
      preLoaderRoute: typeof MarketingRepurchaseRemindersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/referrals/': {
      id: '/marketing/referrals/'
      path: '/marketing/referrals'
      fullPath: '/marketing/referrals/'
      preLoaderRoute: typeof MarketingReferralsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/push-notifications/': {
      id: '/marketing/push-notifications/'
      path: '/marketing/push-notifications'
      fullPath: '/marketing/push-notifications/'
      preLoaderRoute: typeof MarketingPushNotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/product-feeds/': {
      id: '/marketing/product-feeds/'
      path: '/marketing/product-feeds'
      fullPath: '/marketing/product-feeds/'
      preLoaderRoute: typeof MarketingProductFeedsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/loyalty/': {
      id: '/marketing/loyalty/'
      path: '/marketing/loyalty'
      fullPath: '/marketing/loyalty/'
      preLoaderRoute: typeof MarketingLoyaltyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/discounts/': {
      id: '/marketing/discounts/'
      path: '/marketing/discounts'
      fullPath: '/marketing/discounts/'
      preLoaderRoute: typeof MarketingDiscountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/catalog-discounts/': {
      id: '/marketing/catalog-discounts/'
      path: '/marketing/catalog-discounts'
      fullPath: '/marketing/catalog-discounts/'
      preLoaderRoute: typeof MarketingCatalogDiscountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/cashback/': {
      id: '/marketing/cashback/'
      path: '/marketing/cashback'
      fullPath: '/marketing/cashback/'
      preLoaderRoute: typeof MarketingCashbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/calendar/': {
      id: '/marketing/calendar/'
      path: '/marketing/calendar'
      fullPath: '/marketing/calendar/'
      preLoaderRoute: typeof MarketingCalendarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/back-in-stock/': {
      id: '/marketing/back-in-stock/'
      path: '/marketing/back-in-stock'
      fullPath: '/marketing/back-in-stock/'
      preLoaderRoute: typeof MarketingBackInStockIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/automations/': {
      id: '/marketing/automations/'
      path: '/marketing/automations'
      fullPath: '/marketing/automations/'
      preLoaderRoute: typeof MarketingAutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/announcements/': {
      id: '/marketing/announcements/'
      path: '/marketing/announcements'
      fullPath: '/marketing/announcements/'
      preLoaderRoute: typeof MarketingAnnouncementsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/affiliates/': {
      id: '/marketing/affiliates/'
      path: '/marketing/affiliates'
      fullPath: '/marketing/affiliates/'
      preLoaderRoute: typeof MarketingAffiliatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/abandoned-carts/': {
      id: '/marketing/abandoned-carts/'
      path: '/marketing/abandoned-carts'
      fullPath: '/marketing/abandoned-carts/'
      preLoaderRoute: typeof MarketingAbandonedCartsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/transfers/': {
      id: '/inventory/transfers/'
      path: '/inventory/transfers'
      fullPath: '/inventory/transfers/'
      preLoaderRoute: typeof InventoryTransfersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/purchase-orders/': {
      id: '/inventory/purchase-orders/'
      path: '/inventory/purchase-orders'
      fullPath: '/inventory/purchase-orders/'
      preLoaderRoute: typeof InventoryPurchaseOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/history/': {
      id: '/inventory/history/'
      path: '/inventory/history'
      fullPath: '/inventory/history/'
      preLoaderRoute: typeof InventoryHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift-cards/settings/': {
      id: '/gift-cards/settings/'
      path: '/gift-cards/settings'
      fullPath: '/gift-cards/settings/'
      preLoaderRoute: typeof GiftCardsSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift-cards/$id/': {
      id: '/gift-cards/$id/'
      path: '/gift-cards/$id'
      fullPath: '/gift-cards/$id/'
      preLoaderRoute: typeof GiftCardsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/transactions/': {
      id: '/finance/transactions/'
      path: '/transactions'
      fullPath: '/finance/transactions/'
      preLoaderRoute: typeof FinanceTransactionsIndexRouteImport
      parentRoute: typeof FinanceRouteRoute
    }
    '/filters/new/': {
      id: '/filters/new/'
      path: '/filters/new'
      fullPath: '/filters/new/'
      preLoaderRoute: typeof FiltersNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/filters/$id/': {
      id: '/filters/$id/'
      path: '/filters/$id'
      fullPath: '/filters/$id/'
      preLoaderRoute: typeof FiltersIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facets/new/': {
      id: '/facets/new/'
      path: '/facets/new'
      fullPath: '/facets/new/'
      preLoaderRoute: typeof FacetsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facets/$id/': {
      id: '/facets/$id/'
      path: '/facets/$id'
      fullPath: '/facets/$id/'
      preLoaderRoute: typeof FacetsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/smart-segments/': {
      id: '/customers/smart-segments/'
      path: '/customers/smart-segments'
      fullPath: '/customers/smart-segments/'
      preLoaderRoute: typeof CustomersSmartSegmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/rfm/': {
      id: '/customers/rfm/'
      path: '/customers/rfm'
      fullPath: '/customers/rfm/'
      preLoaderRoute: typeof CustomersRfmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/reviews/': {
      id: '/customers/reviews/'
      path: '/customers/reviews'
      fullPath: '/customers/reviews/'
      preLoaderRoute: typeof CustomersReviewsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/review-requests/': {
      id: '/customers/review-requests/'
      path: '/customers/review-requests'
      fullPath: '/customers/review-requests/'
      preLoaderRoute: typeof CustomersReviewRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/questions/': {
      id: '/customers/questions/'
      path: '/customers/questions'
      fullPath: '/customers/questions/'
      preLoaderRoute: typeof CustomersQuestionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/new/': {
      id: '/customers/new/'
      path: '/customers/new'
      fullPath: '/customers/new/'
      preLoaderRoute: typeof CustomersNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/groups/': {
      id: '/customers/groups/'
      path: '/customers/groups'
      fullPath: '/customers/groups/'
      preLoaderRoute: typeof CustomersGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/automations/': {
      id: '/customers/automations/'
      path: '/customers/automations'
      fullPath: '/customers/automations/'
      preLoaderRoute: typeof CustomersAutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$id/': {
      id: '/customers/$id/'
      path: '/customers/$id'
      fullPath: '/customers/$id/'
      preLoaderRoute: typeof CustomersIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/new/': {
      id: '/collections/new/'
      path: '/collections/new'
      fullPath: '/collections/new/'
      preLoaderRoute: typeof CollectionsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/$id/': {
      id: '/collections/$id/'
      path: '/collections/$id'
      fullPath: '/collections/$id/'
      preLoaderRoute: typeof CollectionsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories/new/': {
      id: '/categories/new/'
      path: '/categories/new'
      fullPath: '/categories/new/'
      preLoaderRoute: typeof CategoriesNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories/$id/': {
      id: '/categories/$id/'
      path: '/categories/$id'
      fullPath: '/categories/$id/'
      preLoaderRoute: typeof CategoriesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/labels/': {
      id: '/catalog/labels/'
      path: '/catalog/labels'
      fullPath: '/catalog/labels/'
      preLoaderRoute: typeof CatalogLabelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/new/': {
      id: '/brands/new/'
      path: '/brands/new'
      fullPath: '/brands/new/'
      preLoaderRoute: typeof BrandsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/$id/': {
      id: '/brands/$id/'
      path: '/brands/$id'
      fullPath: '/brands/$id/'
      preLoaderRoute: typeof BrandsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/new/': {
      id: '/blog/new/'
      path: '/blog/new'
      fullPath: '/blog/new/'
      preLoaderRoute: typeof BlogNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/categories/': {
      id: '/blog/categories/'
      path: '/blog/categories'
      fullPath: '/blog/categories/'
      preLoaderRoute: typeof BlogCategoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$id/': {
      id: '/blog/$id/'
      path: '/blog/$id'
      fullPath: '/blog/$id/'
      preLoaderRoute: typeof BlogIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attributes/$id/': {
      id: '/attributes/$id/'
      path: '/attributes/$id'
      fullPath: '/attributes/$id/'
      preLoaderRoute: typeof AttributesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/staff/invite/': {
      id: '/settings/staff/invite/'
      path: '/settings/staff/invite'
      fullPath: '/settings/staff/invite/'
      preLoaderRoute: typeof SettingsStaffInviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/staff/$id/': {
      id: '/settings/staff/$id/'
      path: '/settings/staff/$id'
      fullPath: '/settings/staff/$id/'
      preLoaderRoute: typeof SettingsStaffIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/shipping/manual/': {
      id: '/settings/shipping/manual/'
      path: '/settings/shipping/manual'
      fullPath: '/settings/shipping/manual/'
      preLoaderRoute: typeof SettingsShippingManualIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/shipping/kayn-ship/': {
      id: '/settings/shipping/kayn-ship/'
      path: '/settings/shipping/kayn-ship'
      fullPath: '/settings/shipping/kayn-ship/'
      preLoaderRoute: typeof SettingsShippingKaynShipIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/shipping/$carrierCode/': {
      id: '/settings/shipping/$carrierCode/'
      path: '/settings/shipping/$carrierCode'
      fullPath: '/settings/shipping/$carrierCode/'
      preLoaderRoute: typeof SettingsShippingCarrierCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/scheduling/$id/': {
      id: '/settings/scheduling/$id/'
      path: '/settings/scheduling/$id'
      fullPath: '/settings/scheduling/$id/'
      preLoaderRoute: typeof SettingsSchedulingIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payment-methods/bank-transfer/': {
      id: '/settings/payment-methods/bank-transfer/'
      path: '/settings/payment-methods/bank-transfer'
      fullPath: '/settings/payment-methods/bank-transfer/'
      preLoaderRoute: typeof SettingsPaymentMethodsBankTransferIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payment-methods/activate/': {
      id: '/settings/payment-methods/activate/'
      path: '/settings/payment-methods/activate'
      fullPath: '/settings/payment-methods/activate/'
      preLoaderRoute: typeof SettingsPaymentMethodsActivateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metafield-definitions/new/': {
      id: '/settings/metafield-definitions/new/'
      path: '/settings/metafield-definitions/new'
      fullPath: '/settings/metafield-definitions/new/'
      preLoaderRoute: typeof SettingsMetafieldDefinitionsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metafield-definitions/$id/': {
      id: '/settings/metafield-definitions/$id/'
      path: '/settings/metafield-definitions/$id'
      fullPath: '/settings/metafield-definitions/$id/'
      preLoaderRoute: typeof SettingsMetafieldDefinitionsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/messaging/whatsapp/': {
      id: '/settings/messaging/whatsapp/'
      path: '/settings/messaging/whatsapp'
      fullPath: '/settings/messaging/whatsapp/'
      preLoaderRoute: typeof SettingsMessagingWhatsappIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/messaging/logs/': {
      id: '/settings/messaging/logs/'
      path: '/settings/messaging/logs'
      fullPath: '/settings/messaging/logs/'
      preLoaderRoute: typeof SettingsMessagingLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing/payment-methods/': {
      id: '/settings/billing/payment-methods/'
      path: '/settings/billing/payment-methods'
      fullPath: '/settings/billing/payment-methods/'
      preLoaderRoute: typeof SettingsBillingPaymentMethodsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing/invoices/': {
      id: '/settings/billing/invoices/'
      path: '/settings/billing/invoices'
      fullPath: '/settings/billing/invoices/'
      preLoaderRoute: typeof SettingsBillingInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing/add-ons/': {
      id: '/settings/billing/add-ons/'
      path: '/settings/billing/add-ons'
      fullPath: '/settings/billing/add-ons/'
      preLoaderRoute: typeof SettingsBillingAddOnsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/apps/$appCode/': {
      id: '/settings/apps/$appCode/'
      path: '/settings/apps/$appCode'
      fullPath: '/settings/apps/$appCode/'
      preLoaderRoute: typeof SettingsAppsAppCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/online-store/product-experience/': {
      id: '/sales-channels/online-store/product-experience/'
      path: '/sales-channels/online-store/product-experience'
      fullPath: '/sales-channels/online-store/product-experience/'
      preLoaderRoute: typeof SalesChannelsOnlineStoreProductExperienceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/online-store/design/': {
      id: '/sales-channels/online-store/design/'
      path: '/sales-channels/online-store/design'
      fullPath: '/sales-channels/online-store/design/'
      preLoaderRoute: typeof SalesChannelsOnlineStoreDesignIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-channels/mobile-app/settings/': {
      id: '/sales-channels/mobile-app/settings/'
      path: '/settings'
      fullPath: '/sales-channels/mobile-app/settings/'
      preLoaderRoute: typeof SalesChannelsMobileAppSettingsIndexRouteImport
      parentRoute: typeof SalesChannelsMobileAppRouteRoute
    }
    '/sales-channels/mobile-app/notifications/': {
      id: '/sales-channels/mobile-app/notifications/'
      path: '/notifications'
      fullPath: '/sales-channels/mobile-app/notifications/'
      preLoaderRoute: typeof SalesChannelsMobileAppNotificationsIndexRouteImport
      parentRoute: typeof SalesChannelsMobileAppRouteRoute
    }
    '/sales-channels/mobile-app/identity/': {
      id: '/sales-channels/mobile-app/identity/'
      path: '/identity'
      fullPath: '/sales-channels/mobile-app/identity/'
      preLoaderRoute: typeof SalesChannelsMobileAppIdentityIndexRouteImport
      parentRoute: typeof SalesChannelsMobileAppRouteRoute
    }
    '/sales-channels/mobile-app/homepage/': {
      id: '/sales-channels/mobile-app/homepage/'
      path: '/homepage'
      fullPath: '/sales-channels/mobile-app/homepage/'
      preLoaderRoute: typeof SalesChannelsMobileAppHomepageIndexRouteImport
      parentRoute: typeof SalesChannelsMobileAppRouteRoute
    }
    '/sales-channels/mobile-app/design/': {
      id: '/sales-channels/mobile-app/design/'
      path: '/design'
      fullPath: '/sales-channels/mobile-app/design/'
      preLoaderRoute: typeof SalesChannelsMobileAppDesignIndexRouteImport
      parentRoute: typeof SalesChannelsMobileAppRouteRoute
    }
    '/products/automations/new/': {
      id: '/products/automations/new/'
      path: '/products/automations/new'
      fullPath: '/products/automations/new/'
      preLoaderRoute: typeof ProductsAutomationsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/automations/$id/': {
      id: '/products/automations/$id/'
      path: '/products/automations/$id'
      fullPath: '/products/automations/$id/'
      preLoaderRoute: typeof ProductsAutomationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/returns/$id/': {
      id: '/orders/returns/$id/'
      path: '/orders/returns/$id'
      fullPath: '/orders/returns/$id/'
      preLoaderRoute: typeof OrdersReturnsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/draft/$id/': {
      id: '/orders/draft/$id/'
      path: '/orders/draft/$id'
      fullPath: '/orders/draft/$id/'
      preLoaderRoute: typeof OrdersDraftIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/automations/new/': {
      id: '/orders/automations/new/'
      path: '/orders/automations/new'
      fullPath: '/orders/automations/new/'
      preLoaderRoute: typeof OrdersAutomationsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/automations/$id/': {
      id: '/orders/automations/$id/'
      path: '/orders/automations/$id'
      fullPath: '/orders/automations/$id/'
      preLoaderRoute: typeof OrdersAutomationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$id/modify/': {
      id: '/orders/$id/modify/'
      path: '/orders/$id/modify'
      fullPath: '/orders/$id/modify/'
      preLoaderRoute: typeof OrdersIdModifyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/referrals/settings/': {
      id: '/marketing/referrals/settings/'
      path: '/marketing/referrals/settings'
      fullPath: '/marketing/referrals/settings/'
      preLoaderRoute: typeof MarketingReferralsSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/discounts/new/': {
      id: '/marketing/discounts/new/'
      path: '/marketing/discounts/new'
      fullPath: '/marketing/discounts/new/'
      preLoaderRoute: typeof MarketingDiscountsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/discounts/$id/': {
      id: '/marketing/discounts/$id/'
      path: '/marketing/discounts/$id'
      fullPath: '/marketing/discounts/$id/'
      preLoaderRoute: typeof MarketingDiscountsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/catalog-discounts/new/': {
      id: '/marketing/catalog-discounts/new/'
      path: '/marketing/catalog-discounts/new'
      fullPath: '/marketing/catalog-discounts/new/'
      preLoaderRoute: typeof MarketingCatalogDiscountsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/catalog-discounts/$id/': {
      id: '/marketing/catalog-discounts/$id/'
      path: '/marketing/catalog-discounts/$id'
      fullPath: '/marketing/catalog-discounts/$id/'
      preLoaderRoute: typeof MarketingCatalogDiscountsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/cashback/new/': {
      id: '/marketing/cashback/new/'
      path: '/marketing/cashback/new'
      fullPath: '/marketing/cashback/new/'
      preLoaderRoute: typeof MarketingCashbackNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/cashback/$id/': {
      id: '/marketing/cashback/$id/'
      path: '/marketing/cashback/$id'
      fullPath: '/marketing/cashback/$id/'
      preLoaderRoute: typeof MarketingCashbackIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/automations/secrets/': {
      id: '/marketing/automations/secrets/'
      path: '/marketing/automations/secrets'
      fullPath: '/marketing/automations/secrets/'
      preLoaderRoute: typeof MarketingAutomationsSecretsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/automations/new/': {
      id: '/marketing/automations/new/'
      path: '/marketing/automations/new'
      fullPath: '/marketing/automations/new/'
      preLoaderRoute: typeof MarketingAutomationsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/automations/$id/': {
      id: '/marketing/automations/$id/'
      path: '/marketing/automations/$id'
      fullPath: '/marketing/automations/$id/'
      preLoaderRoute: typeof MarketingAutomationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/affiliates/settings/': {
      id: '/marketing/affiliates/settings/'
      path: '/marketing/affiliates/settings'
      fullPath: '/marketing/affiliates/settings/'
      preLoaderRoute: typeof MarketingAffiliatesSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/affiliates/new/': {
      id: '/marketing/affiliates/new/'
      path: '/marketing/affiliates/new'
      fullPath: '/marketing/affiliates/new/'
      preLoaderRoute: typeof MarketingAffiliatesNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/affiliates/$id/': {
      id: '/marketing/affiliates/$id/'
      path: '/marketing/affiliates/$id'
      fullPath: '/marketing/affiliates/$id/'
      preLoaderRoute: typeof MarketingAffiliatesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/transfers/new/': {
      id: '/inventory/transfers/new/'
      path: '/inventory/transfers/new'
      fullPath: '/inventory/transfers/new/'
      preLoaderRoute: typeof InventoryTransfersNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/transfers/$id/': {
      id: '/inventory/transfers/$id/'
      path: '/inventory/transfers/$id'
      fullPath: '/inventory/transfers/$id/'
      preLoaderRoute: typeof InventoryTransfersIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/purchase-orders/vendors/': {
      id: '/inventory/purchase-orders/vendors/'
      path: '/inventory/purchase-orders/vendors'
      fullPath: '/inventory/purchase-orders/vendors/'
      preLoaderRoute: typeof InventoryPurchaseOrdersVendorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/purchase-orders/new/': {
      id: '/inventory/purchase-orders/new/'
      path: '/inventory/purchase-orders/new'
      fullPath: '/inventory/purchase-orders/new/'
      preLoaderRoute: typeof InventoryPurchaseOrdersNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/purchase-orders/$id/': {
      id: '/inventory/purchase-orders/$id/'
      path: '/inventory/purchase-orders/$id'
      fullPath: '/inventory/purchase-orders/$id/'
      preLoaderRoute: typeof InventoryPurchaseOrdersIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/reviews/$id/': {
      id: '/customers/reviews/$id/'
      path: '/customers/reviews/$id'
      fullPath: '/customers/reviews/$id/'
      preLoaderRoute: typeof CustomersReviewsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/groups/new/': {
      id: '/customers/groups/new/'
      path: '/customers/groups/new'
      fullPath: '/customers/groups/new/'
      preLoaderRoute: typeof CustomersGroupsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/groups/$id/': {
      id: '/customers/groups/$id/'
      path: '/customers/groups/$id'
      fullPath: '/customers/groups/$id/'
      preLoaderRoute: typeof CustomersGroupsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/automations/new/': {
      id: '/customers/automations/new/'
      path: '/customers/automations/new'
      fullPath: '/customers/automations/new/'
      preLoaderRoute: typeof CustomersAutomationsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/automations/$id/': {
      id: '/customers/automations/$id/'
      path: '/customers/automations/$id'
      fullPath: '/customers/automations/$id/'
      preLoaderRoute: typeof CustomersAutomationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$id/edit/': {
      id: '/customers/$id/edit/'
      path: '/customers/$id/edit'
      fullPath: '/customers/$id/edit/'
      preLoaderRoute: typeof CustomersIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/labels/settings/': {
      id: '/catalog/labels/settings/'
      path: '/catalog/labels/settings'
      fullPath: '/catalog/labels/settings/'
      preLoaderRoute: typeof CatalogLabelsSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/labels/new/': {
      id: '/catalog/labels/new/'
      path: '/catalog/labels/new'
      fullPath: '/catalog/labels/new/'
      preLoaderRoute: typeof CatalogLabelsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/labels/$id/': {
      id: '/catalog/labels/$id/'
      path: '/catalog/labels/$id'
      fullPath: '/catalog/labels/$id/'
      preLoaderRoute: typeof CatalogLabelsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/shipping/kayn-ship/wallet/': {
      id: '/settings/shipping/kayn-ship/wallet/'
      path: '/settings/shipping/kayn-ship/wallet'
      fullPath: '/settings/shipping/kayn-ship/wallet/'
      preLoaderRoute: typeof SettingsShippingKaynShipWalletIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/messaging/whatsapp/templates/': {
      id: '/settings/messaging/whatsapp/templates/'
      path: '/settings/messaging/whatsapp/templates'
      fullPath: '/settings/messaging/whatsapp/templates/'
      preLoaderRoute: typeof SettingsMessagingWhatsappTemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/automations/$id/logs/': {
      id: '/products/automations/$id/logs/'
      path: '/products/automations/$id/logs'
      fullPath: '/products/automations/$id/logs/'
      preLoaderRoute: typeof ProductsAutomationsIdLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/automations/$id/logs/': {
      id: '/orders/automations/$id/logs/'
      path: '/orders/automations/$id/logs'
      fullPath: '/orders/automations/$id/logs/'
      preLoaderRoute: typeof OrdersAutomationsIdLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/automations/$id/logs/': {
      id: '/marketing/automations/$id/logs/'
      path: '/marketing/automations/$id/logs'
      fullPath: '/marketing/automations/$id/logs/'
      preLoaderRoute: typeof MarketingAutomationsIdLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/purchase-orders/vendors/new/': {
      id: '/inventory/purchase-orders/vendors/new/'
      path: '/inventory/purchase-orders/vendors/new'
      fullPath: '/inventory/purchase-orders/vendors/new/'
      preLoaderRoute: typeof InventoryPurchaseOrdersVendorsNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/purchase-orders/vendors/$id/': {
      id: '/inventory/purchase-orders/vendors/$id/'
      path: '/inventory/purchase-orders/vendors/$id'
      fullPath: '/inventory/purchase-orders/vendors/$id/'
      preLoaderRoute: typeof InventoryPurchaseOrdersVendorsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/groups/$id/edit/': {
      id: '/customers/groups/$id/edit/'
      path: '/customers/groups/$id/edit'
      fullPath: '/customers/groups/$id/edit/'
      preLoaderRoute: typeof CustomersGroupsIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/automations/$id/logs/': {
      id: '/customers/automations/$id/logs/'
      path: '/customers/automations/$id/logs'
      fullPath: '/customers/automations/$id/logs/'
      preLoaderRoute: typeof CustomersAutomationsIdLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface FinanceRouteRouteChildren {
  FinanceIndexRoute: typeof FinanceIndexRoute
  FinanceTransactionsIndexRoute: typeof FinanceTransactionsIndexRoute
}

const FinanceRouteRouteChildren: FinanceRouteRouteChildren = {
  FinanceIndexRoute: FinanceIndexRoute,
  FinanceTransactionsIndexRoute: FinanceTransactionsIndexRoute,
}

const FinanceRouteRouteWithChildren = FinanceRouteRoute._addFileChildren(
  FinanceRouteRouteChildren,
)

interface ReportsRouteRouteChildren {
  ReportsIndexRoute: typeof ReportsIndexRoute
  ReportsCustomersIndexRoute: typeof ReportsCustomersIndexRoute
  ReportsFinancialIndexRoute: typeof ReportsFinancialIndexRoute
  ReportsLoyaltyIndexRoute: typeof ReportsLoyaltyIndexRoute
  ReportsOrdersIndexRoute: typeof ReportsOrdersIndexRoute
  ReportsProductsIndexRoute: typeof ReportsProductsIndexRoute
  ReportsSalesIndexRoute: typeof ReportsSalesIndexRoute
}

const ReportsRouteRouteChildren: ReportsRouteRouteChildren = {
  ReportsIndexRoute: ReportsIndexRoute,
  ReportsCustomersIndexRoute: ReportsCustomersIndexRoute,
  ReportsFinancialIndexRoute: ReportsFinancialIndexRoute,
  ReportsLoyaltyIndexRoute: ReportsLoyaltyIndexRoute,
  ReportsOrdersIndexRoute: ReportsOrdersIndexRoute,
  ReportsProductsIndexRoute: ReportsProductsIndexRoute,
  ReportsSalesIndexRoute: ReportsSalesIndexRoute,
}

const ReportsRouteRouteWithChildren = ReportsRouteRoute._addFileChildren(
  ReportsRouteRouteChildren,
)

interface SalesChannelsMobileAppRouteRouteChildren {
  SalesChannelsMobileAppIndexRoute: typeof SalesChannelsMobileAppIndexRoute
  SalesChannelsMobileAppDesignIndexRoute: typeof SalesChannelsMobileAppDesignIndexRoute
  SalesChannelsMobileAppHomepageIndexRoute: typeof SalesChannelsMobileAppHomepageIndexRoute
  SalesChannelsMobileAppIdentityIndexRoute: typeof SalesChannelsMobileAppIdentityIndexRoute
  SalesChannelsMobileAppNotificationsIndexRoute: typeof SalesChannelsMobileAppNotificationsIndexRoute
  SalesChannelsMobileAppSettingsIndexRoute: typeof SalesChannelsMobileAppSettingsIndexRoute
}

const SalesChannelsMobileAppRouteRouteChildren: SalesChannelsMobileAppRouteRouteChildren =
  {
    SalesChannelsMobileAppIndexRoute: SalesChannelsMobileAppIndexRoute,
    SalesChannelsMobileAppDesignIndexRoute:
      SalesChannelsMobileAppDesignIndexRoute,
    SalesChannelsMobileAppHomepageIndexRoute:
      SalesChannelsMobileAppHomepageIndexRoute,
    SalesChannelsMobileAppIdentityIndexRoute:
      SalesChannelsMobileAppIdentityIndexRoute,
    SalesChannelsMobileAppNotificationsIndexRoute:
      SalesChannelsMobileAppNotificationsIndexRoute,
    SalesChannelsMobileAppSettingsIndexRoute:
      SalesChannelsMobileAppSettingsIndexRoute,
  }

const SalesChannelsMobileAppRouteRouteWithChildren =
  SalesChannelsMobileAppRouteRoute._addFileChildren(
    SalesChannelsMobileAppRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FinanceRouteRoute: FinanceRouteRouteWithChildren,
  ReportsRouteRoute: ReportsRouteRouteWithChildren,
  SalesChannelsMobileAppRouteRoute:
    SalesChannelsMobileAppRouteRouteWithChildren,
  AcceptInviteIndexRoute: AcceptInviteIndexRoute,
  AttributesIndexRoute: AttributesIndexRoute,
  BlogIndexRoute: BlogIndexRoute,
  BrandsIndexRoute: BrandsIndexRoute,
  CapabilitiesIndexRoute: CapabilitiesIndexRoute,
  CategoriesIndexRoute: CategoriesIndexRoute,
  CollectionsIndexRoute: CollectionsIndexRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  FacetsIndexRoute: FacetsIndexRoute,
  FiltersIndexRoute: FiltersIndexRoute,
  GiftCardsIndexRoute: GiftCardsIndexRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  PagesIndexRoute: PagesIndexRoute,
  ProductPropertiesIndexRoute: ProductPropertiesIndexRoute,
  ProductTemplatesIndexRoute: ProductTemplatesIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  SalesChannelsIndexRoute: SalesChannelsIndexRoute,
  SelectStoreIndexRoute: SelectStoreIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SignupIndexRoute: SignupIndexRoute,
  StockLocationsIndexRoute: StockLocationsIndexRoute,
  Verify2faIndexRoute: Verify2faIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
  AttributesIdIndexRoute: AttributesIdIndexRoute,
  BlogIdIndexRoute: BlogIdIndexRoute,
  BlogCategoriesIndexRoute: BlogCategoriesIndexRoute,
  BlogNewIndexRoute: BlogNewIndexRoute,
  BrandsIdIndexRoute: BrandsIdIndexRoute,
  BrandsNewIndexRoute: BrandsNewIndexRoute,
  CatalogLabelsIndexRoute: CatalogLabelsIndexRoute,
  CategoriesIdIndexRoute: CategoriesIdIndexRoute,
  CategoriesNewIndexRoute: CategoriesNewIndexRoute,
  CollectionsIdIndexRoute: CollectionsIdIndexRoute,
  CollectionsNewIndexRoute: CollectionsNewIndexRoute,
  CustomersIdIndexRoute: CustomersIdIndexRoute,
  CustomersAutomationsIndexRoute: CustomersAutomationsIndexRoute,
  CustomersGroupsIndexRoute: CustomersGroupsIndexRoute,
  CustomersNewIndexRoute: CustomersNewIndexRoute,
  CustomersQuestionsIndexRoute: CustomersQuestionsIndexRoute,
  CustomersReviewRequestsIndexRoute: CustomersReviewRequestsIndexRoute,
  CustomersReviewsIndexRoute: CustomersReviewsIndexRoute,
  CustomersRfmIndexRoute: CustomersRfmIndexRoute,
  CustomersSmartSegmentsIndexRoute: CustomersSmartSegmentsIndexRoute,
  FacetsIdIndexRoute: FacetsIdIndexRoute,
  FacetsNewIndexRoute: FacetsNewIndexRoute,
  FiltersIdIndexRoute: FiltersIdIndexRoute,
  FiltersNewIndexRoute: FiltersNewIndexRoute,
  GiftCardsIdIndexRoute: GiftCardsIdIndexRoute,
  GiftCardsSettingsIndexRoute: GiftCardsSettingsIndexRoute,
  InventoryHistoryIndexRoute: InventoryHistoryIndexRoute,
  InventoryPurchaseOrdersIndexRoute: InventoryPurchaseOrdersIndexRoute,
  InventoryTransfersIndexRoute: InventoryTransfersIndexRoute,
  MarketingAbandonedCartsIndexRoute: MarketingAbandonedCartsIndexRoute,
  MarketingAffiliatesIndexRoute: MarketingAffiliatesIndexRoute,
  MarketingAnnouncementsIndexRoute: MarketingAnnouncementsIndexRoute,
  MarketingAutomationsIndexRoute: MarketingAutomationsIndexRoute,
  MarketingBackInStockIndexRoute: MarketingBackInStockIndexRoute,
  MarketingCalendarIndexRoute: MarketingCalendarIndexRoute,
  MarketingCashbackIndexRoute: MarketingCashbackIndexRoute,
  MarketingCatalogDiscountsIndexRoute: MarketingCatalogDiscountsIndexRoute,
  MarketingDiscountsIndexRoute: MarketingDiscountsIndexRoute,
  MarketingLoyaltyIndexRoute: MarketingLoyaltyIndexRoute,
  MarketingProductFeedsIndexRoute: MarketingProductFeedsIndexRoute,
  MarketingPushNotificationsIndexRoute: MarketingPushNotificationsIndexRoute,
  MarketingReferralsIndexRoute: MarketingReferralsIndexRoute,
  MarketingRepurchaseRemindersIndexRoute:
    MarketingRepurchaseRemindersIndexRoute,
  MarketingSalesBoostersIndexRoute: MarketingSalesBoostersIndexRoute,
  MarketingSegmentsIndexRoute: MarketingSegmentsIndexRoute,
  MarketingSeoIndexRoute: MarketingSeoIndexRoute,
  OrdersIdIndexRoute: OrdersIdIndexRoute,
  OrdersAutomationsIndexRoute: OrdersAutomationsIndexRoute,
  OrdersDraftsIndexRoute: OrdersDraftsIndexRoute,
  OrdersFulfilmentIndexRoute: OrdersFulfilmentIndexRoute,
  OrdersInvoicesIndexRoute: OrdersInvoicesIndexRoute,
  OrdersNewIndexRoute: OrdersNewIndexRoute,
  OrdersReturnsIndexRoute: OrdersReturnsIndexRoute,
  OrdersShipmentsIndexRoute: OrdersShipmentsIndexRoute,
  PagesIdIndexRoute: PagesIdIndexRoute,
  PagesNewIndexRoute: PagesNewIndexRoute,
  ProductsIdIndexRoute: ProductsIdIndexRoute,
  ProductsAutomationsIndexRoute: ProductsAutomationsIndexRoute,
  ProductsBulkEditIndexRoute: ProductsBulkEditIndexRoute,
  ProductsNewIndexRoute: ProductsNewIndexRoute,
  SalesChannelsOnlineStoreIndexRoute: SalesChannelsOnlineStoreIndexRoute,
  SalesChannelsPosIndexRoute: SalesChannelsPosIndexRoute,
  SettingsAppsIndexRoute: SettingsAppsIndexRoute,
  SettingsBillingIndexRoute: SettingsBillingIndexRoute,
  SettingsCheckoutRestrictionsIndexRoute:
    SettingsCheckoutRestrictionsIndexRoute,
  SettingsCheckoutRiskIndexRoute: SettingsCheckoutRiskIndexRoute,
  SettingsCheckoutIndexRoute: SettingsCheckoutIndexRoute,
  SettingsContentBlocksIndexRoute: SettingsContentBlocksIndexRoute,
  SettingsDataMigrationIndexRoute: SettingsDataMigrationIndexRoute,
  SettingsDomainsIndexRoute: SettingsDomainsIndexRoute,
  SettingsGiftOptionsIndexRoute: SettingsGiftOptionsIndexRoute,
  SettingsIntegrationsIndexRoute: SettingsIntegrationsIndexRoute,
  SettingsInventoryIndexRoute: SettingsInventoryIndexRoute,
  SettingsInvoicesIndexRoute: SettingsInvoicesIndexRoute,
  SettingsLanguagesIndexRoute: SettingsLanguagesIndexRoute,
  SettingsLocalizationIndexRoute: SettingsLocalizationIndexRoute,
  SettingsMarketsIndexRoute: SettingsMarketsIndexRoute,
  SettingsMessagingIndexRoute: SettingsMessagingIndexRoute,
  SettingsMetafieldDefinitionsIndexRoute:
    SettingsMetafieldDefinitionsIndexRoute,
  SettingsNotificationsIndexRoute: SettingsNotificationsIndexRoute,
  SettingsOperationsIndexRoute: SettingsOperationsIndexRoute,
  SettingsOrderCustomizationsIndexRoute: SettingsOrderCustomizationsIndexRoute,
  SettingsPaymentMethodsIndexRoute: SettingsPaymentMethodsIndexRoute,
  SettingsProfileIndexRoute: SettingsProfileIndexRoute,
  SettingsReturnPolicyIndexRoute: SettingsReturnPolicyIndexRoute,
  SettingsSchedulingIndexRoute: SettingsSchedulingIndexRoute,
  SettingsSecurityIndexRoute: SettingsSecurityIndexRoute,
  SettingsShippingIndexRoute: SettingsShippingIndexRoute,
  SettingsStaffIndexRoute: SettingsStaffIndexRoute,
  SettingsStoreIndexRoute: SettingsStoreIndexRoute,
  SettingsTaxIndexRoute: SettingsTaxIndexRoute,
  SettingsTestimonialsIndexRoute: SettingsTestimonialsIndexRoute,
  StockLocationsIdIndexRoute: StockLocationsIdIndexRoute,
  StockLocationsNewIndexRoute: StockLocationsNewIndexRoute,
  CatalogLabelsIdIndexRoute: CatalogLabelsIdIndexRoute,
  CatalogLabelsNewIndexRoute: CatalogLabelsNewIndexRoute,
  CatalogLabelsSettingsIndexRoute: CatalogLabelsSettingsIndexRoute,
  CustomersIdEditIndexRoute: CustomersIdEditIndexRoute,
  CustomersAutomationsIdIndexRoute: CustomersAutomationsIdIndexRoute,
  CustomersAutomationsNewIndexRoute: CustomersAutomationsNewIndexRoute,
  CustomersGroupsIdIndexRoute: CustomersGroupsIdIndexRoute,
  CustomersGroupsNewIndexRoute: CustomersGroupsNewIndexRoute,
  CustomersReviewsIdIndexRoute: CustomersReviewsIdIndexRoute,
  InventoryPurchaseOrdersIdIndexRoute: InventoryPurchaseOrdersIdIndexRoute,
  InventoryPurchaseOrdersNewIndexRoute: InventoryPurchaseOrdersNewIndexRoute,
  InventoryPurchaseOrdersVendorsIndexRoute:
    InventoryPurchaseOrdersVendorsIndexRoute,
  InventoryTransfersIdIndexRoute: InventoryTransfersIdIndexRoute,
  InventoryTransfersNewIndexRoute: InventoryTransfersNewIndexRoute,
  MarketingAffiliatesIdIndexRoute: MarketingAffiliatesIdIndexRoute,
  MarketingAffiliatesNewIndexRoute: MarketingAffiliatesNewIndexRoute,
  MarketingAffiliatesSettingsIndexRoute: MarketingAffiliatesSettingsIndexRoute,
  MarketingAutomationsIdIndexRoute: MarketingAutomationsIdIndexRoute,
  MarketingAutomationsNewIndexRoute: MarketingAutomationsNewIndexRoute,
  MarketingAutomationsSecretsIndexRoute: MarketingAutomationsSecretsIndexRoute,
  MarketingCashbackIdIndexRoute: MarketingCashbackIdIndexRoute,
  MarketingCashbackNewIndexRoute: MarketingCashbackNewIndexRoute,
  MarketingCatalogDiscountsIdIndexRoute: MarketingCatalogDiscountsIdIndexRoute,
  MarketingCatalogDiscountsNewIndexRoute:
    MarketingCatalogDiscountsNewIndexRoute,
  MarketingDiscountsIdIndexRoute: MarketingDiscountsIdIndexRoute,
  MarketingDiscountsNewIndexRoute: MarketingDiscountsNewIndexRoute,
  MarketingReferralsSettingsIndexRoute: MarketingReferralsSettingsIndexRoute,
  OrdersIdModifyIndexRoute: OrdersIdModifyIndexRoute,
  OrdersAutomationsIdIndexRoute: OrdersAutomationsIdIndexRoute,
  OrdersAutomationsNewIndexRoute: OrdersAutomationsNewIndexRoute,
  OrdersDraftIdIndexRoute: OrdersDraftIdIndexRoute,
  OrdersReturnsIdIndexRoute: OrdersReturnsIdIndexRoute,
  ProductsAutomationsIdIndexRoute: ProductsAutomationsIdIndexRoute,
  ProductsAutomationsNewIndexRoute: ProductsAutomationsNewIndexRoute,
  SalesChannelsOnlineStoreDesignIndexRoute:
    SalesChannelsOnlineStoreDesignIndexRoute,
  SalesChannelsOnlineStoreProductExperienceIndexRoute:
    SalesChannelsOnlineStoreProductExperienceIndexRoute,
  SettingsAppsAppCodeIndexRoute: SettingsAppsAppCodeIndexRoute,
  SettingsBillingAddOnsIndexRoute: SettingsBillingAddOnsIndexRoute,
  SettingsBillingInvoicesIndexRoute: SettingsBillingInvoicesIndexRoute,
  SettingsBillingPaymentMethodsIndexRoute:
    SettingsBillingPaymentMethodsIndexRoute,
  SettingsMessagingLogsIndexRoute: SettingsMessagingLogsIndexRoute,
  SettingsMessagingWhatsappIndexRoute: SettingsMessagingWhatsappIndexRoute,
  SettingsMetafieldDefinitionsIdIndexRoute:
    SettingsMetafieldDefinitionsIdIndexRoute,
  SettingsMetafieldDefinitionsNewIndexRoute:
    SettingsMetafieldDefinitionsNewIndexRoute,
  SettingsPaymentMethodsActivateIndexRoute:
    SettingsPaymentMethodsActivateIndexRoute,
  SettingsPaymentMethodsBankTransferIndexRoute:
    SettingsPaymentMethodsBankTransferIndexRoute,
  SettingsSchedulingIdIndexRoute: SettingsSchedulingIdIndexRoute,
  SettingsShippingCarrierCodeIndexRoute: SettingsShippingCarrierCodeIndexRoute,
  SettingsShippingKaynShipIndexRoute: SettingsShippingKaynShipIndexRoute,
  SettingsShippingManualIndexRoute: SettingsShippingManualIndexRoute,
  SettingsStaffIdIndexRoute: SettingsStaffIdIndexRoute,
  SettingsStaffInviteIndexRoute: SettingsStaffInviteIndexRoute,
  CustomersAutomationsIdLogsIndexRoute: CustomersAutomationsIdLogsIndexRoute,
  CustomersGroupsIdEditIndexRoute: CustomersGroupsIdEditIndexRoute,
  InventoryPurchaseOrdersVendorsIdIndexRoute:
    InventoryPurchaseOrdersVendorsIdIndexRoute,
  InventoryPurchaseOrdersVendorsNewIndexRoute:
    InventoryPurchaseOrdersVendorsNewIndexRoute,
  MarketingAutomationsIdLogsIndexRoute: MarketingAutomationsIdLogsIndexRoute,
  OrdersAutomationsIdLogsIndexRoute: OrdersAutomationsIdLogsIndexRoute,
  ProductsAutomationsIdLogsIndexRoute: ProductsAutomationsIdLogsIndexRoute,
  SettingsMessagingWhatsappTemplatesIndexRoute:
    SettingsMessagingWhatsappTemplatesIndexRoute,
  SettingsShippingKaynShipWalletIndexRoute:
    SettingsShippingKaynShipWalletIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
